import * as i0 from '@angular/core';
import { Component, inject, Injectable, ChangeDetectionStrategy, ViewChild, EventEmitter, Input, Output, ViewChildren, Pipe, HostBinding, NgModule } from '@angular/core';
import * as i1 from '@spartacus/storefront';
import { LAUNCH_CALLER, ICON_TYPE, CustomFormValidators, DIALOG_TYPE, DirectionMode, BREAKPOINT, FormErrorsModule, IconModule, SpinnerModule, PasswordVisibilityToggleModule, KeyboardFocusModule, NgSelectA11yModule, SortingModule, PaginationModule, MessageComponentModule } from '@spartacus/storefront';
import * as i1$1 from '@spartacus/core';
import { GlobalMessageType, useFeatureStyles, RoutingService, FeatureConfigService, OCC_CART_ID_CURRENT, HttpResponseStatus, I18nModule, FeaturesConfigModule, provideDefaultConfig } from '@spartacus/core';
import * as i1$2 from '@angular/forms';
import { FormControl, Validators, UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BehaviorSubject, Subscription, combineLatest, iif, defer, EMPTY, of, NEVER } from 'rxjs';
import { take, map, shareReplay, filter, tap, concatMap, finalize, first, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import * as i2 from '@spartacus/cart/saved-cart/root';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$2 from '@spartacus/cart/base/root';
import * as i2$1 from '@spartacus/asm/root';
import { ASM_ENABLED_LOCAL_STORAGE_KEY, CustomerListColumnActionType, CLOSE_DIALOG_REASON } from '@spartacus/asm/root';
import { AsmDialogActionType } from '@spartacus/asm/customer-360/root';
import * as i6 from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import * as i2$3 from '@spartacus/asm/core';
import * as i2$4 from '@spartacus/user/account/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function AsmSaveCartDialogComponent_ng_container_7_cx_message_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function AsmSaveCartDialogComponent_ng_container_7_cx_message_2_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.closeDialogAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "asm.saveCart.dialog.saveInfo"))("type", ctx_r2.globalMessageType.MSG_TYPE_INFO);
  }
}
function AsmSaveCartDialogComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵtemplate(2, AsmSaveCartDialogComponent_ng_container_7_cx_message_2_Template, 2, 4, "cx-message", 16);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 1, ctx_r2.showDialogAlert$));
  }
}
function AsmSaveCartDialogComponent_ng_template_8_cx_message_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function AsmSaveCartDialogComponent_ng_template_8_cx_message_1_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.closeDialogAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "asm.saveCart.dialog.disableInfo"))("type", ctx_r2.globalMessageType.MSG_TYPE_WARNING);
  }
}
function AsmSaveCartDialogComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, AsmSaveCartDialogComponent_ng_template_8_cx_message_1_Template, 2, 4, "cx-message", 16);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.showDialogAlert$));
  }
}
function AsmSaveCartDialogComponent_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.saveCart.dialog.row.qtyFull"), " ");
  }
}
function AsmSaveCartDialogComponent_div_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.saveCart.dialog.row.qty"), " ");
  }
}
const _c0 = ["bindToCart"];
const _c1 = ["saveInactiveCart"];
const _c2 = (a0, a1) => ({
  "cx-asm-assignCart": a0,
  "cx-asm-assignCart-input-show-no-button": a1
});
function AsmBindCartComponent_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function AsmBindCartComponent_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.clearText());
    });
    i0.ɵɵelement(3, "cx-icon", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("visible", (ctx_r3.cartId.value == null ? null : ctx_r3.cartId.value.length) > 0);
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(1, 4, "asm.bindCart.resetCartId"))("aria-label", i0.ɵɵpipeBind1(2, 6, "asm.bindCart.resetCartId"));
  }
}
function AsmBindCartComponent_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11, 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵlistener("click", function AsmBindCartComponent_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.bindCartToCustomer());
    });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "cx-dot-spinner");
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("cx-asm-active", i0.ɵɵpipeBind1(2, 9, ctx_r3.valid$))("cx-bind-loading", i0.ɵɵpipeBind1(3, 11, ctx_r3.loading$));
    i0.ɵɵproperty("disabled", !i0.ɵɵpipeBind1(4, 13, ctx_r3.valid$));
    i0.ɵɵadvance(5);
    i0.ɵɵattribute("aria-hidden", i0.ɵɵpipeBind1(6, 15, ctx_r3.loading$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 17, "asm.bindCart.bindCartToCustomer"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-hidden", !i0.ɵɵpipeBind1(10, 19, ctx_r3.loading$))("aria-label", i0.ɵɵpipeBind1(11, 21, "common.loading"));
  }
}
function AsmBindCartComponent_button_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12, 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function AsmBindCartComponent_button_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onSaveInactiveCart());
    });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "cx-dot-spinner");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("cx-bind-loading", i0.ɵɵpipeBind1(2, 6, ctx_r3.loading$));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-hidden", i0.ɵɵpipeBind1(4, 8, ctx_r3.loading$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 10, "asm.saveCart.saveCartBtn"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-hidden", !i0.ɵɵpipeBind1(8, 12, ctx_r3.loading$))("aria-label", i0.ɵɵpipeBind1(9, 14, "common.loading"));
  }
}
function AsmCreateCustomerFormComponent_cx_message_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 14);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function AsmCreateCustomerFormComponent_cx_message_10_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.closeDialogInfoAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "asm.createCustomerForm.createAccountAlert"))("type", ctx_r2.globalMessageType.MSG_TYPE_INFO);
  }
}
function AsmCreateCustomerFormComponent_ng_container_11_cx_message_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 14);
    i0.ɵɵlistener("closeMessage", function AsmCreateCustomerFormComponent_ng_container_11_cx_message_1_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const i_r5 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.closeDialogBackendErroAlert(i_r5));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const errorMessage_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("text", errorMessage_r6)("type", ctx_r2.globalMessageType.MSG_TYPE_ERROR);
  }
}
function AsmCreateCustomerFormComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AsmCreateCustomerFormComponent_ng_container_11_cx_message_1_Template, 1, 2, "cx-message", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const i_r5 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showDialogBackendErrorAlerts[i_r5]);
  }
}
function AsmCreateCustomerFormComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 15)(2, "label")(3, "span", 16);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "input", 17);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelement(8, "cx-form-errors", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 15)(10, "label")(11, "span", 16);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 19);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelement(16, "cx-form-errors", 20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 15)(18, "label")(19, "span", 16);
    i0.ɵɵtext(20);
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "input", 21);
    i0.ɵɵpipe(23, "cxTranslate");
    i0.ɵɵelement(24, "cx-form-errors", 22);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_4_0;
    let tmp_9_0;
    let tmp_14_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 15, "asm.createCustomerForm.firstName.label"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 17, "asm.createCustomerForm.firstName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_4_0 = ctx_r2.registerForm.get("firstName")) == null ? null : tmp_4_0.touched) && ((tmp_4_0 = ctx_r2.registerForm.get("firstName")) == null ? null : tmp_4_0.invalid))("aria-errormessage", "firstNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r2.registerForm.get("firstName"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(13, 19, "asm.createCustomerForm.lastName.label"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(15, 21, "asm.createCustomerForm.lastName.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_9_0 = ctx_r2.registerForm.get("lastName")) == null ? null : tmp_9_0.touched) && ((tmp_9_0 = ctx_r2.registerForm.get("lastName")) == null ? null : tmp_9_0.invalid))("aria-errormessage", "lastNameError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r2.registerForm.get("lastName"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(21, 23, "asm.createCustomerForm.emailAddress.label"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(23, 25, "asm.createCustomerForm.emailAddress.placeholder"));
    i0.ɵɵattribute("aria-invalid", ((tmp_14_0 = ctx_r2.registerForm.get("email")) == null ? null : tmp_14_0.touched) && ((tmp_14_0 = ctx_r2.registerForm.get("email")) == null ? null : tmp_14_0.invalid))("aria-errormessage", "emailError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r2.registerForm.get("email"));
  }
}
function AsmCreateCustomerFormComponent_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c3 = a0 => ({
  label: a0
});
function CSAgentLoginFormComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 2);
    i0.ɵɵlistener("ngSubmit", function CSAgentLoginFormComponent_form_0_Template_form_ngSubmit_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label");
    i0.ɵɵelement(5, "input", 4);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelement(7, "cx-form-errors", 5);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 3);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label");
    i0.ɵɵelement(13, "input", 6);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelement(15, "cx-form-errors", 7);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 8);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_4_0;
    let tmp_10_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.csAgentLoginForm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 14, "asm.loginForm.userId.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 16, "asm.loginForm.userId.label"))("aria-invalid", ((tmp_4_0 = ctx_r1.csAgentLoginForm.get("userId")) == null ? null : tmp_4_0.touched) && ((tmp_4_0 = ctx_r1.csAgentLoginForm.get("userId")) == null ? null : tmp_4_0.invalid))("aria-errormessage", "userIdError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(28, _c3, i0.ɵɵpipeBind1(8, 18, "asm.loginForm.userId.label")))("control", ctx_r1.csAgentLoginForm.get("userId"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 20, "asm.loginForm.password.label"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(14, 22, "asm.loginForm.password.label"))("aria-invalid", ((tmp_10_0 = ctx_r1.csAgentLoginForm.get("password")) == null ? null : tmp_10_0.touched) && ((tmp_10_0 = ctx_r1.csAgentLoginForm.get("password")) == null ? null : tmp_10_0.invalid))("aria-errormessage", "passwordError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(30, _c3, i0.ɵɵpipeBind1(16, 24, "asm.loginForm.password.label")))("control", ctx_r1.csAgentLoginForm.get("password"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 26, "asm.loginForm.submit"), " ");
  }
}
function CSAgentLoginFormComponent_cx_dot_spinner_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-dot-spinner", 9);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loading"));
  }
}
const _c4 = ["resultList"];
const _c5 = ["searchTerm"];
const _c6 = ["searchOrder"];
const _c7 = ["createCustomerLink"];
const _c8 = ["searchResultItem"];
function CustomerSelectionComponent_form_0_div_9_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "div", 17)(3, "span", 18);
    i0.ɵɵelement(4, "cx-icon", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 20);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 21, 3);
    i0.ɵɵlistener("click", function CustomerSelectionComponent_form_0_div_9_div_2_Template_span_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.createCustomer());
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(7, 2, "asm.customerSearch.noCustomerMatchResult"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 4, "asm.customerSearch.createCustomer"), " ");
  }
}
function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24, 4);
    i0.ɵɵlistener("keydown.arrowup", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_arrowup_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusPreviousChild($event));
    })("keydown.arrowdown", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_arrowdown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusNextChild($event));
    })("keydown.arrowright", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_arrowright_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.arrowleft", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_arrowleft_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.enter", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_enter_0_listener($event) {
      const result_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.selectCustomerFromList($event, result_r5));
    })("keydown.escape", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_escape_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.closeResults($event));
    })("keydown.home", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_home_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.end", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_keydown_end_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("click", function CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template_button_click_0_listener($event) {
      const result_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.selectCustomerFromList($event, result_r5));
    });
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 26)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const result_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵclassProp("active", ctx_r1.activeFocusedButtonIndex === i_r6);
    i0.ɵɵproperty("tabindex", ctx_r1.activeFocusedButtonIndex === i_r6 ? 0 : -1);
    i0.ɵɵattribute("aria-selected", ctx_r1.activeFocusedButtonIndex === i_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(result_r5.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(result_r5.uid);
  }
}
function CustomerSelectionComponent_form_0_div_9_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, CustomerSelectionComponent_form_0_div_9_div_3_button_1_Template, 7, 6, "button", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const results_r7 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", results_r7.entries);
  }
}
function CustomerSelectionComponent_form_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 2);
    i0.ɵɵtemplate(2, CustomerSelectionComponent_form_0_div_9_div_2_Template, 12, 6, "div", 14)(3, CustomerSelectionComponent_form_0_div_9_div_3_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const results_r7 = ctx.ngIf;
    i0.ɵɵnextContext();
    const searchTerm_r8 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isNoResultMessageInfoVisible(results_r7, ctx_r1.searchByCustomer, searchTerm_r8));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSearchResultsVisible(results_r7, ctx_r1.searchByCustomer));
  }
}
function CustomerSelectionComponent_form_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "cx-dot-spinner", 27);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "common.loading"));
  }
}
function CustomerSelectionComponent_form_0_div_20_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "div", 17)(3, "span", 18);
    i0.ɵɵelement(4, "cx-icon", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 20);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 1, "asm.customerSearch.noOrderMatchResult"), " ");
  }
}
function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24, 4);
    i0.ɵɵlistener("keydown.arrowup", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_arrowup_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusPreviousChild($event));
    })("keydown.arrowdown", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_arrowdown_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusNextChild($event));
    })("keydown.arrowright", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_arrowright_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusOrderSearchInputText($event));
    })("keydown.arrowleft", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_arrowleft_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusOrderSearchInputText($event));
    })("keydown.enter", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_enter_0_listener($event) {
      const result_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.selectCustomerFromList($event, result_r10));
    })("keydown.escape", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_escape_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.closeOrderSearchResults($event));
    })("keydown.home", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_home_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusOrderSearchInputText($event));
    })("keydown.end", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_keydown_end_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusOrderSearchInputText($event));
    })("click", function CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template_button_click_0_listener($event) {
      const result_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.selectCustomerFromList($event, result_r10));
    });
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 26)(5, "span");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const result_r10 = ctx.$implicit;
    const i_r11 = ctx.index;
    i0.ɵɵnextContext(3);
    const searchOrder_r12 = i0.ɵɵreference(17);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", ctx_r1.activeFocusedButtonIndex === i_r11);
    i0.ɵɵproperty("tabindex", ctx_r1.activeFocusedButtonIndex === i_r11 ? 0 : -1);
    i0.ɵɵattribute("aria-selected", ctx_r1.activeFocusedButtonIndex === i_r11);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(searchOrder_r12.value);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(result_r10.name);
  }
}
function CustomerSelectionComponent_form_0_div_20_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, CustomerSelectionComponent_form_0_div_20_div_3_button_1_Template, 7, 6, "button", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const results_r13 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", results_r13.entries);
  }
}
function CustomerSelectionComponent_form_0_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 2);
    i0.ɵɵtemplate(2, CustomerSelectionComponent_form_0_div_20_div_2_Template, 8, 3, "div", 14)(3, CustomerSelectionComponent_form_0_div_20_div_3_Template, 2, 1, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const results_r13 = ctx.ngIf;
    i0.ɵɵnextContext();
    const searchOrder_r12 = i0.ɵɵreference(17);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isNoResultMessageInfoVisible(results_r13, ctx_r1.searchByOrder, searchOrder_r12));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSearchResultsVisible(results_r13, ctx_r1.searchByOrder));
  }
}
function CustomerSelectionComponent_form_0_div_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "cx-dot-spinner", 27);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "common.loading"));
  }
}
function CustomerSelectionComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 7);
    i0.ɵɵlistener("ngSubmit", function CustomerSelectionComponent_form_0_Template_form_ngSubmit_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label")(5, "input", 9, 0);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵlistener("keydown.arrowdown", function CustomerSelectionComponent_form_0_Template_input_keydown_arrowdown_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusFirstItem($event));
    })("keydown.end", function CustomerSelectionComponent_form_0_Template_input_keydown_end_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setSelectionEnd($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, CustomerSelectionComponent_form_0_div_9_Template, 4, 2, "div", 10);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵtemplate(11, CustomerSelectionComponent_form_0_div_11_Template, 3, 3, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 8);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "label")(16, "input", 12, 1);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵlistener("keydown.arrowdown", function CustomerSelectionComponent_form_0_Template_input_keydown_arrowdown_16_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusFirstItem($event));
    })("keydown.end", function CustomerSelectionComponent_form_0_Template_input_keydown_end_16_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setOrderSearchSelectionEnd($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, CustomerSelectionComponent_form_0_div_20_Template, 4, 2, "div", 10);
    i0.ɵɵpipe(21, "async");
    i0.ɵɵtemplate(22, CustomerSelectionComponent_form_0_div_22_Template, 3, 3, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "button", 13);
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.customerSelectionForm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 15, "asm.customerSearch.customer"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 17, "asm.customerSearch.searchCustomer.label"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 19, "asm.customerSearch.searchCustomer.label"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 21, ctx_r1.searchResults));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isLoading && ctx_r1.searchByCustomer);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 23, "asm.customerSearch.orderID"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 25, "asm.customerSearch.searchOrder.label"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(19, 27, "asm.customerSearch.searchOrder.label"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(21, 29, ctx_r1.searchResults));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.isLoading && ctx_r1.searchByOrder);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r1.selectedCustomer);
    i0.ɵɵproperty("disabled", !ctx_r1.selectedCustomer);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 31, "asm.customerSearch.submit"), " ");
  }
}
function CustomerSelectionComponent_div_1_div_12_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24, 4);
    i0.ɵɵlistener("keydown.arrowup", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_arrowup_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusPreviousChild($event));
    })("keydown.arrowdown", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_arrowdown_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusNextChild($event));
    })("keydown.arrowright", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_arrowright_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.arrowleft", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_arrowleft_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.enter", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_enter_0_listener($event) {
      const result_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectCustomerFromList($event, result_r16));
    })("keydown.escape", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_escape_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.closeResults($event));
    })("keydown.home", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_home_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.end", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_keydown_end_0_listener($event) {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("click", function CustomerSelectionComponent_div_1_div_12_button_2_Template_button_click_0_listener($event) {
      const result_r16 = i0.ɵɵrestoreView(_r15).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectCustomerFromList($event, result_r16));
    });
    i0.ɵɵelementStart(2, "span", 25);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 26);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const result_r16 = ctx.$implicit;
    const i_r17 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("active", ctx_r1.activeFocusedButtonIndex === i_r17);
    i0.ɵɵproperty("tabindex", ctx_r1.activeFocusedButtonIndex === i_r17 ? 0 : -1);
    i0.ɵɵattribute("aria-selected", ctx_r1.activeFocusedButtonIndex === i_r17);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(result_r16.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(result_r16.uid);
  }
}
function CustomerSelectionComponent_div_1_div_12_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31, 4);
    i0.ɵɵlistener("click", function CustomerSelectionComponent_div_1_div_12_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.createCustomer());
    })("keydown.escape", function CustomerSelectionComponent_div_1_div_12_button_3_Template_button_keydown_escape_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.closeResults($event));
    })("keydown.arrowright", function CustomerSelectionComponent_div_1_div_12_button_3_Template_button_keydown_arrowright_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.arrowleft", function CustomerSelectionComponent_div_1_div_12_button_3_Template_button_keydown_arrowleft_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.home", function CustomerSelectionComponent_div_1_div_12_button_3_Template_button_keydown_home_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    })("keydown.end", function CustomerSelectionComponent_div_1_div_12_button_3_Template_button_keydown_end_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.focusInputText($event));
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 32, 3);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("active", ctx_r1.activeFocusedButtonIndex === 0);
    i0.ɵɵattribute("aria-selected", ctx_r1.activeFocusedButtonIndex === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, "asm.customerSearch.noMatchResult"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 7, "asm.customerSearch.createCustomer"));
  }
}
function CustomerSelectionComponent_div_1_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22, 2);
    i0.ɵɵtemplate(2, CustomerSelectionComponent_div_1_div_12_button_2_Template, 6, 6, "button", 23)(3, CustomerSelectionComponent_div_1_div_12_button_3_Template, 9, 9, "button", 30);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const results_r19 = ctx.ngIf;
    i0.ɵɵnextContext();
    const searchTerm_r20 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", results_r19.entries);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(4, 2, ctx_r1.searchResultsLoading$) && searchTerm_r20.value.length >= 3 && !!results_r19.entries && results_r19.entries.length <= 0);
  }
}
function CustomerSelectionComponent_div_1_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "cx-dot-spinner", 27);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 1, "common.loading"));
  }
}
function CustomerSelectionComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "form", 7);
    i0.ɵɵlistener("ngSubmit", function CustomerSelectionComponent_div_1_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSubmit());
    });
    i0.ɵɵelementStart(2, "label")(3, "input", 9, 0);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("keydown.arrowdown", function CustomerSelectionComponent_div_1_Template_input_keydown_arrowdown_3_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusFirstItem($event));
    })("keydown.end", function CustomerSelectionComponent_div_1_Template_input_keydown_end_3_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.setSelectionEnd($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "cx-form-errors", 28);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 29);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(12, CustomerSelectionComponent_div_1_div_12_Template, 5, 4, "div", 11);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵtemplate(14, CustomerSelectionComponent_div_1_div_14_Template, 3, 3, "div", 11);
    i0.ɵɵpipe(15, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.customerSelectionForm);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(5, 12, "asm.customerSearch.searchTerm.label"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 14, "asm.customerSearch.searchTerm.label"))("aria-invalid", ((tmp_5_0 = ctx_r1.customerSelectionForm.get("searchTerm")) == null ? null : tmp_5_0.touched) && ((tmp_5_0 = ctx_r1.customerSelectionForm.get("searchTerm")) == null ? null : tmp_5_0.invalid))("aria-errormessage", "searchTermError");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(24, _c3, i0.ɵɵpipeBind1(8, 16, "asm.customerSearch.searchTerm.label")))("control", ctx_r1.customerSelectionForm.get("searchTerm"));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("active", ctx_r1.selectedCustomer);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 18, "asm.customerSearch.submit"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 20, ctx_r1.searchResults));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(15, 22, ctx_r1.searchResultsLoading$));
  }
}
const _c9 = ["asmCustomer360Launcher"];
function CustomerEmulationComponent_ng_container_0_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7, 0);
    i0.ɵɵlistener("click", function CustomerEmulationComponent_ng_container_0_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.openAsmCustomer360());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "asm.asmCustomer360ViewButton"), " ");
  }
}
function CustomerEmulationComponent_ng_container_0_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7, 0);
    i0.ɵɵlistener("click", function CustomerEmulationComponent_ng_container_0_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.openAsmCustomer360());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "asm.asmCustomer360Button"), " ");
  }
}
function CustomerEmulationComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "label", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "cx-asm-bind-cart");
    i0.ɵɵtemplate(7, CustomerEmulationComponent_ng_container_0_button_7_Template, 4, 3, "button", 5)(8, CustomerEmulationComponent_ng_container_0_button_8_Template, 4, 3, "button", 5);
    i0.ɵɵelementStart(9, "button", 6);
    i0.ɵɵlistener("click", function CustomerEmulationComponent_ng_container_0_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.logoutCustomer());
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.customer == null ? null : ctx_r2.customer.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.customer == null ? null : ctx_r2.customer.uid);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isAsmCustomer360Configured && ctx_r2.customer && ctx_r2.isShowStyleChangesInASM);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isAsmCustomer360Configured && ctx_r2.customer && !ctx_r2.isShowStyleChangesInASM);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 5, "asm.endSession"), " ");
  }
}
function AsmToggleUiComponent_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.toggleUi.collapse"), " ");
  }
}
function AsmToggleUiComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.toggleUi.expand"), " ");
  }
}
const _c10 = ["customerListLink"];
const _c11 = ["addNewCustomerLink"];
function AsmMainUiComponent_div_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "a", 16, 0);
    i0.ɵɵlistener("click", function AsmMainUiComponent_div_15_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showCustomList());
    });
    i0.ɵɵelement(3, "cx-icon", 10);
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.USER_FRIENDS);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 2, "asm.customers"));
  }
}
function AsmMainUiComponent_cx_asm_session_timer_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-asm-session-timer");
  }
}
function AsmMainUiComponent_button_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("click", function AsmMainUiComponent_button_20_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.hideUi());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "asm.hideUi"));
  }
}
function AsmMainUiComponent_button_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("click", function AsmMainUiComponent_button_23_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.logout());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "asm.logout"));
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_customer_emulation_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-customer-emulation");
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 21);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_2_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.closeDialogConfirmationAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "asm.createCustomerSuccessfullyAlert"))("type", ctx_r1.globalMessageType.MSG_TYPE_CONFIRMATION);
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 21);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_3_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.closeDeeplinkCartInfoAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, ctx_r1.deeplinkCartAlertKey))("type", ctx_r1.globalMessageType.MSG_TYPE_INFO);
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 21);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_5_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.closeCustomerEmulationInfoAlert());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 2, "asm.startCustomerEmulationAlertInfo"))("type", ctx_r1.globalMessageType.MSG_TYPE_INFO);
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_customer_emulation_1_Template, 1, 0, "cx-customer-emulation", 12)(2, AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_2_Template, 2, 4, "cx-message", 20)(3, AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_3_Template, 2, 4, "cx-message", 20);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_cx_message_5_Template, 2, 4, "cx-message", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const notCollapsed_r8 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notCollapsed_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", notCollapsed_r8 && ctx_r1.showCreateCustomerSuccessfullyAlert);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r1.showDeeplinkCartInfoAlert$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", notCollapsed_r8 && ctx_r1.showCustomerEmulationInfoAlert);
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_ng_template_3_cx_customer_selection_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-customer-selection", 23);
    i0.ɵɵlistener("submitEvent", function AsmMainUiComponent_ng_container_25_ng_container_1_ng_template_3_cx_customer_selection_0_Template_cx_customer_selection_submitEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.startCustomerEmulationSession($event, $event.parameters));
    });
    i0.ɵɵelementEnd();
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AsmMainUiComponent_ng_container_25_ng_container_1_ng_template_3_cx_customer_selection_0_Template, 1, 0, "cx-customer-selection", 22);
  }
  if (rf & 2) {
    const notCollapsed_r8 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("ngIf", notCollapsed_r8);
  }
}
function AsmMainUiComponent_ng_container_25_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AsmMainUiComponent_ng_container_25_ng_container_1_ng_container_1_Template, 6, 6, "ng-container", 19);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, AsmMainUiComponent_ng_container_25_ng_container_1_ng_template_3_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const showCustomerSelection_r10 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.customer$))("ngIfElse", showCustomerSelection_r10);
  }
}
function AsmMainUiComponent_ng_container_25_ng_template_3_cx_csagent_login_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-csagent-login-form", 25);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("submitEvent", function AsmMainUiComponent_ng_container_25_ng_template_3_cx_csagent_login_form_0_Template_cx_csagent_login_form_submitEvent_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.loginCustomerSupportAgent($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("csAgentTokenLoading", i0.ɵɵpipeBind1(1, 1, ctx_r1.csAgentTokenLoading$));
  }
}
function AsmMainUiComponent_ng_container_25_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AsmMainUiComponent_ng_container_25_ng_template_3_cx_csagent_login_form_0_Template, 2, 3, "cx-csagent-login-form", 24);
  }
  if (rf & 2) {
    const notCollapsed_r8 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("ngIf", notCollapsed_r8);
  }
}
function AsmMainUiComponent_ng_container_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AsmMainUiComponent_ng_container_25_ng_container_1_Template, 5, 4, "ng-container", 19);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, AsmMainUiComponent_ng_container_25_ng_template_3_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const showLoginForm_r12 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.customerSupportAgentLoggedIn$))("ngIfElse", showLoginForm_r12);
  }
}
const _c12 = (a0, a1) => ({
  customerA: a0,
  customerB: a1
});
const _c13 = a0 => ({
  customerListsPage: a0
});
const _c14 = a0 => ({
  customerSearchPage: a0
});
const _c15 = (a0, a1) => ({
  customerEntry: a0,
  column: a1,
  showHeader: false
});
const _c16 = (a0, a1) => ({
  customerEntry: a0,
  column: a1,
  showHeader: true
});
const _c17 = (a0, a1) => ({
  column: a0,
  customerEntry: a1
});
const _c18 = a0 => ({
  count: a0
});
const _c19 = a0 => ({
  ariaLabel: a0,
  ariaControls: "asm-cusomer-list-table"
});
function CustomerListComponent_10_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_10_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_11_4_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_11_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_11_4_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_11_5_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_11_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_11_5_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_11_9_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_11_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_11_9_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_11_10_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_11_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_11_10_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementStart(2, "div", 25);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, CustomerListComponent_div_11_4_Template, 1, 0, null, 26)(5, CustomerListComponent_div_11_5_Template, 1, 0, null, 26);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 27);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, CustomerListComponent_div_11_9_Template, 1, 0, null, 14)(10, CustomerListComponent_div_11_10_Template, 1, 0, null, 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const customerListsPage_r2 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    const search_r4 = i0.ɵɵreference(35);
    const total_r5 = i0.ɵɵreference(37);
    const sort_r6 = i0.ɵɵreference(39);
    const groupSelector_r7 = i0.ɵɵreference(43);
    i0.ɵɵclassProp("tablet-mobile", i0.ɵɵpipeBind1(1, 12, ctx_r2.breakpoint$) !== ctx_r2.BREAKPOINT.md);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("mobile", i0.ɵɵpipeBind1(3, 14, ctx_r2.breakpoint$) === ctx_r2.BREAKPOINT.xs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", groupSelector_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(20, _c13, customerListsPage_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", total_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(22, _c14, i0.ɵɵpipeBind1(6, 16, ctx_r2.customerSearchPage$)));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("mobile", i0.ɵɵpipeBind1(8, 18, ctx_r2.breakpoint$) === ctx_r2.BREAKPOINT.xs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", sort_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", search_r4);
  }
}
function CustomerListComponent_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.customerList.noLists"), " ");
  }
}
function CustomerListComponent_div_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.customerList.listsError"), " ");
  }
}
function CustomerListComponent_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "generalErrors.pageFailure"), " ");
  }
}
function CustomerListComponent_cx_spinner_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-spinner");
  }
}
function CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.customerList.tableHeader.customerName"), " ");
  }
}
function CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.customerList.tableHeader.emailId"), " ");
  }
}
function CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r8 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, column_r8.headerLocalizationKey), " ");
  }
}
function CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_ng_container_1_Template, 3, 3, "ng-container", 20)(2, CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_ng_container_2_Template, 3, 3, "ng-container", 20)(3, CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_ng_container_3_Template, 3, 3, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r8.headerLocalizationKey === "asm.customerList.tableHeader.customer");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r8.headerLocalizationKey === "asm.customerList.tableHeader.email");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r8.headerLocalizationKey !== "asm.customerList.tableHeader.customer" && column_r8.headerLocalizationKey !== "asm.customerList.tableHeader.email");
  }
}
function CustomerListComponent_div_22_table_1_thead_4_th_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 36);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_thead_4_th_2_span_1_Template, 4, 3, "span", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r8.headerLocalizationKey && column_r8.headerLocalizationKey !== "hideHeaders");
  }
}
function CustomerListComponent_div_22_table_1_thead_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead")(1, "tr", 34);
    i0.ɵɵtemplate(2, CustomerListComponent_div_22_table_1_thead_4_th_2_Template, 2, 1, "th", 35);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.customerListConfig == null ? null : ctx_r2.customerListConfig.columns);
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_1_td_1_1_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_1_td_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_22_table_1_tr_7_ng_container_1_td_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_1_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 39);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_ng_container_1_td_1_1_Template, 1, 0, null, 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r9 = ctx.$implicit;
    const customerEntry_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const cell_r11 = i0.ɵɵreference(31);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cell_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c15, customerEntry_r10, column_r9));
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_ng_container_1_td_1_Template, 2, 5, "td", 38);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.customerListConfig == null ? null : ctx_r2.customerListConfig.columns);
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_ng_container_1_1_Template, 1, 0, null, 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r12 = i0.ɵɵnextContext().$implicit;
    const customerEntry_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const cell_r11 = i0.ɵɵreference(31);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cell_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c16, customerEntry_r10, column_r12));
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_ng_container_1_Template, 2, 5, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const even_r13 = ctx.even;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", even_r13);
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_ng_container_1_1_Template, 1, 0, null, 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r14 = i0.ɵɵnextContext().$implicit;
    const customerEntry_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const cell_r11 = i0.ɵɵreference(31);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cell_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c16, customerEntry_r10, column_r14));
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_ng_container_1_Template, 2, 5, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const odd_r15 = ctx.odd;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", odd_r15);
  }
}
function CustomerListComponent_div_22_table_1_tr_7_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 40);
    i0.ɵɵtemplate(2, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_2_Template, 2, 1, "ng-container", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td", 40);
    i0.ɵɵtemplate(4, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_ng_container_4_Template, 2, 1, "ng-container", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.customerListConfig == null ? null : ctx_r2.customerListConfig.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.customerListConfig == null ? null : ctx_r2.customerListConfig.columns);
  }
}
function CustomerListComponent_div_22_table_1_tr_7_td_5_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function CustomerListComponent_div_22_table_1_tr_7_td_5_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_div_22_table_1_tr_7_td_5_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function CustomerListComponent_div_22_table_1_tr_7_td_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_td_5_ng_container_1_1_Template, 1, 0, null, 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const column_r16 = ctx.$implicit;
    const customerEntry_r10 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const cell_r11 = i0.ɵɵreference(31);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cell_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c16, customerEntry_r10, column_r16));
  }
}
function CustomerListComponent_div_22_table_1_tr_7_td_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 40);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_td_5_ng_container_1_Template, 2, 5, "ng-container", 41);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.customerListConfig == null ? null : ctx_r2.customerListConfig.columns);
  }
}
function CustomerListComponent_div_22_table_1_tr_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 34);
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_tr_7_ng_container_1_Template, 2, 1, "ng-container", 20);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, CustomerListComponent_div_22_table_1_tr_7_ng_container_3_Template, 5, 2, "ng-container", 20);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, CustomerListComponent_div_22_table_1_tr_7_td_5_Template, 2, 1, "td", 37);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx_r2.breakpoint$) === ctx_r2.BREAKPOINT.md);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 5, ctx_r2.breakpoint$) === ctx_r2.BREAKPOINT.sm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 7, ctx_r2.breakpoint$) === ctx_r2.BREAKPOINT.xs);
  }
}
function CustomerListComponent_div_22_table_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 31)(1, "caption", 32);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomerListComponent_div_22_table_1_thead_4_Template, 3, 1, "thead", 20);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementStart(6, "tbody");
    i0.ɵɵtemplate(7, CustomerListComponent_div_22_table_1_tr_7_Template, 7, 9, "tr", 33);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const customerSearchPage_r17 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "asm.customerList.title"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 5, ctx_r2.breakpoint$) === ctx_r2.BREAKPOINT.md);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", customerSearchPage_r17 == null ? null : customerSearchPage_r17.entries);
  }
}
function CustomerListComponent_div_22_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.customerList.noCustomers"), " ");
  }
}
function CustomerListComponent_div_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CustomerListComponent_div_22_table_1_Template, 8, 7, "table", 29)(2, CustomerListComponent_div_22_div_2_Template, 3, 3, "div", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customerSearchPage_r17 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loaded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(customerSearchPage_r17 == null ? null : customerSearchPage_r17.entries.length));
  }
}
function CustomerListComponent_div_24_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "cx-pagination", 44);
    i0.ɵɵlistener("viewPageEvent", function CustomerListComponent_div_24_div_4_Template_cx_pagination_viewPageEvent_1_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.changePage($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const customerSearchPage_r19 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("pagination", customerSearchPage_r19.pagination);
  }
}
function CustomerListComponent_div_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementStart(2, "div", 27);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, CustomerListComponent_div_24_div_4_Template, 2, 1, "div", 20);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("asm-mobile-pagination", i0.ɵɵpipeBind1(1, 5, ctx_r2.breakpoint$) !== ctx_r2.BREAKPOINT.md);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("mobile", i0.ɵɵpipeBind1(3, 7, ctx_r2.breakpoint$) === ctx_r2.BREAKPOINT.xs);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 9, ctx_r2.customerSearchPage$));
  }
}
function CustomerListComponent_ng_template_30_div_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 50);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r20 = i0.ɵɵnextContext(2).column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, column_r20.headerLocalizationKey), " ");
  }
}
function CustomerListComponent_ng_template_30_div_0_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CustomerListComponent_ng_template_30_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CustomerListComponent_ng_template_30_div_0_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 26);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    const customerEntry_r22 = ctx_r20.customerEntry;
    const column_r20 = ctx_r20.column;
    i0.ɵɵnextContext();
    const cellContent_r23 = i0.ɵɵreference(33);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cellContent_r23)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c17, column_r20, customerEntry_r22));
  }
}
function CustomerListComponent_ng_template_30_div_0_div_3_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 54);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
  }
  if (rf & 2) {
    const customerEntry_r22 = i0.ɵɵnextContext(3).customerEntry;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("alt", i0.ɵɵpipeBind1(1, 3, "asm.mainLogoLabel"));
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 5, "asm.mainLogoLabel"));
    i0.ɵɵattribute("src", (ctx_r2.occConfig == null ? null : ctx_r2.occConfig.backend == null ? null : ctx_r2.occConfig.backend.occ == null ? null : ctx_r2.occConfig.backend.occ.baseUrl) + (customerEntry_r22 == null ? null : customerEntry_r22.userAvatar == null ? null : customerEntry_r22.userAvatar.url), i0.ɵɵsanitizeUrl);
  }
}
function CustomerListComponent_ng_template_30_div_0_div_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customerEntry_r22 = i0.ɵɵnextContext(3).customerEntry;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getBadgeText(customerEntry_r22), " ");
  }
}
function CustomerListComponent_ng_template_30_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 51);
    i0.ɵɵtemplate(1, CustomerListComponent_ng_template_30_div_0_div_3_img_1_Template, 3, 7, "img", 52)(2, CustomerListComponent_ng_template_30_div_0_div_3_div_2_Template, 2, 1, "div", 53);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customerEntry_r22 = i0.ɵɵnextContext(2).customerEntry;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", customerEntry_r22 == null ? null : customerEntry_r22.userAvatar == null ? null : customerEntry_r22.userAvatar.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(customerEntry_r22 == null ? null : customerEntry_r22.userAvatar == null ? null : customerEntry_r22.userAvatar.url));
  }
}
function CustomerListComponent_ng_template_30_div_0_button_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CustomerListComponent_ng_template_30_div_0_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 56);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function CustomerListComponent_ng_template_30_div_0_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const ctx_r20 = i0.ɵɵnextContext(2);
      const customerEntry_r22 = ctx_r20.customerEntry;
      const column_r20 = ctx_r20.column;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.startColumnAction(customerEntry_r22, column_r20.actionType));
    });
    i0.ɵɵtemplate(3, CustomerListComponent_ng_template_30_div_0_button_4_ng_container_3_Template, 1, 0, "ng-container", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_17_0;
    let tmp_18_0;
    const ctx_r20 = i0.ɵɵnextContext(2);
    const customerEntry_r22 = ctx_r20.customerEntry;
    const column_r20 = ctx_r20.column;
    const ctx_r2 = i0.ɵɵnextContext();
    const cellContent_r23 = i0.ɵɵreference(33);
    i0.ɵɵclassMap((column_r20.actionType === "ACTIVE_CART" ? "cx-cart " : "") + (column_r20.actionType !== "START_SESSION" ? "cx-action-disable" : ""));
    i0.ɵɵproperty("disabled", ctx_r2.isRequired(customerEntry_r22, column_r20.actionType));
    i0.ɵɵattribute("title", column_r20.icon ? i0.ɵɵpipeBind1(1, 7, (tmp_17_0 = column_r20.icon.captionLocalizationKey) !== null && tmp_17_0 !== undefined ? tmp_17_0 : column_r20.headerLocalizationKey) : undefined)("aria-label", column_r20.icon ? i0.ɵɵpipeBind1(2, 9, (tmp_18_0 = column_r20.icon.captionLocalizationKey) !== null && tmp_18_0 !== undefined ? tmp_18_0 : column_r20.headerLocalizationKey) : undefined);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", cellContent_r23)("ngTemplateOutletContext", i0.ɵɵpureFunction2(11, _c17, column_r20, customerEntry_r22));
  }
}
function CustomerListComponent_ng_template_30_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, CustomerListComponent_ng_template_30_div_0_span_1_Template, 3, 3, "span", 47)(2, CustomerListComponent_ng_template_30_div_0_ng_container_2_Template, 2, 5, "ng-container", 20)(3, CustomerListComponent_ng_template_30_div_0_div_3_Template, 3, 2, "div", 48)(4, CustomerListComponent_ng_template_30_div_0_button_4_Template, 4, 14, "button", 49);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    const column_r20 = ctx_r20.column;
    const showHeader_r25 = ctx_r20.showHeader;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", showHeader_r25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r20.actionType);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r2.customerListConfig == null ? null : ctx_r2.customerListConfig.showAvatar) && (column_r20 == null ? null : column_r20.actionType) === (ctx_r2.customerListColumnActionType == null ? null : ctx_r2.customerListColumnActionType.START_SESSION));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r20.actionType);
  }
}
function CustomerListComponent_ng_template_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_ng_template_30_div_0_Template, 5, 4, "div", 45);
  }
  if (rf & 2) {
    const column_r20 = ctx.column;
    i0.ɵɵproperty("ngIf", column_r20.headerLocalizationKey !== "hideHeaders");
  }
}
function CustomerListComponent_ng_template_32_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext();
    const customerEntry_r27 = ctx_r25.customerEntry;
    const column_r28 = ctx_r25.column;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((column_r28.renderer == null ? null : column_r28.renderer(customerEntry_r27)) || "");
  }
}
function CustomerListComponent_ng_template_32_cx_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 58);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
  }
  if (rf & 2) {
    let tmp_15_0;
    let tmp_16_0;
    const ctx_r25 = i0.ɵɵnextContext();
    const customerEntry_r27 = ctx_r25.customerEntry;
    const column_r28 = ctx_r25.column;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("cx-action-color", column_r28.actionType && !ctx_r2.isRequired(customerEntry_r27, column_r28.actionType));
    i0.ɵɵproperty("type", column_r28.icon.symbol);
    i0.ɵɵattribute("title", !column_r28.actionType ? i0.ɵɵpipeBind1(1, 5, (tmp_15_0 = column_r28.icon.captionLocalizationKey) !== null && tmp_15_0 !== undefined ? tmp_15_0 : column_r28.headerLocalizationKey) : undefined)("aria-label", !column_r28.actionType ? i0.ɵɵpipeBind1(2, 7, (tmp_16_0 = column_r28.icon.captionLocalizationKey) !== null && tmp_16_0 !== undefined ? tmp_16_0 : column_r28.headerLocalizationKey) : undefined);
  }
}
function CustomerListComponent_ng_template_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CustomerListComponent_ng_template_32_span_1_Template, 2, 1, "span", 20)(2, CustomerListComponent_ng_template_32_cx_icon_2_Template, 3, 9, "cx-icon", 57);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const column_r28 = ctx.column;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !column_r28.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", column_r28.icon);
  }
}
function CustomerListComponent_ng_template_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 59)(1, "input", 60);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵlistener("keyup", function CustomerListComponent_ng_template_34_Template_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r29);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onKey($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "cx-icon", 61);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵlistener("click", function CustomerListComponent_ng_template_34_Template_cx_icon_click_4_listener() {
      i0.ɵɵrestoreView(_r29);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.searchCustomers());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(2, 6, "asm.customerList.searchBox"));
    i0.ɵɵproperty("formControl", ctx_r2.searchBox);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 8, "asm.customerList.enterSearchBox"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.SEARCH)("title", i0.ɵɵpipeBind1(5, 10, "storeFinder.searchNearestStores"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 12, "storeFinder.searchNearestStores"));
  }
}
function CustomerListComponent_ng_template_36_span_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const customerSearchPage_r30 = i0.ɵɵnextContext(2).customerSearchPage;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "asm.customerList.noOfCustomers", i0.ɵɵpureFunction1(4, _c18, customerSearchPage_r30 == null ? null : customerSearchPage_r30.pagination == null ? null : customerSearchPage_r30.pagination.totalResults)), " ");
  }
}
function CustomerListComponent_ng_template_36_span_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "asm.customerList.oneCustomer"), " ");
  }
}
function CustomerListComponent_ng_template_36_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 63);
    i0.ɵɵtemplate(1, CustomerListComponent_ng_template_36_span_0_ng_container_1_Template, 3, 6, "ng-container", 20)(2, CustomerListComponent_ng_template_36_span_0_ng_container_2_Template, 3, 3, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const customerSearchPage_r30 = i0.ɵɵnextContext().customerSearchPage;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (customerSearchPage_r30 == null ? null : customerSearchPage_r30.pagination == null ? null : customerSearchPage_r30.pagination.totalResults) > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (customerSearchPage_r30 == null ? null : customerSearchPage_r30.pagination == null ? null : customerSearchPage_r30.pagination.totalResults) === 1);
  }
}
function CustomerListComponent_ng_template_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CustomerListComponent_ng_template_36_span_0_Template, 3, 2, "span", 62);
  }
  if (rf & 2) {
    const customerSearchPage_r30 = ctx.customerSearchPage;
    i0.ɵɵproperty("ngIf", customerSearchPage_r30 == null ? null : customerSearchPage_r30.pagination == null ? null : customerSearchPage_r30.pagination.totalResults);
  }
}
function CustomerListComponent_ng_template_38_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 67);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "asm.customerList.tableSort.sortBy"));
  }
}
function CustomerListComponent_ng_template_38_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "asm.customerList.tableSort.sortBy"));
  }
}
function CustomerListComponent_ng_template_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtemplate(1, CustomerListComponent_ng_template_38_span_1_Template, 3, 3, "span", 64)(2, CustomerListComponent_ng_template_38_span_2_Template, 3, 3, "span", 65);
    i0.ɵɵelementStart(3, "cx-sorting", 66);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵlistener("sortListEvent", function CustomerListComponent_ng_template_38_Template_cx_sorting_sortListEvent_3_listener($event) {
      i0.ɵɵrestoreView(_r31);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeSortCode($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yShowLabelOfSelect");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yShowLabelOfSelect");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(4, 7, "asm.customerList.tableSort.sortBy"));
    i0.ɵɵproperty("sortOptions", ctx_r2.sorts)("sortLabels", i0.ɵɵpipeBind1(5, 9, ctx_r2.getSortLabels()))("selectedOption", ctx_r2.sortCode)("ariaLabel", ctx_r2.sortCode);
  }
}
function CustomerListComponent_ng_template_40_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 71);
    i0.ɵɵlistener("click", function CustomerListComponent_ng_template_40_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r32);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.goToPreviousPage());
    });
    i0.ɵɵelement(1, "cx-icon", 72);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2.currentPage === 0 || !ctx_r2.loaded);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r2.iconTypes.CARET_LEFT);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "asm.customerList.page.previous"));
  }
}
function CustomerListComponent_ng_template_40_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 73);
    i0.ɵɵlistener("click", function CustomerListComponent_ng_template_40_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r33);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.goToNextPage());
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "cx-icon", 74);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2.currentPage === ctx_r2.maxPage || !ctx_r2.loaded);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, "asm.customerList.page.next"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.CARET_RIGHT);
  }
}
function CustomerListComponent_ng_template_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomerListComponent_ng_template_40_button_4_Template, 5, 5, "button", 69)(5, CustomerListComponent_ng_template_40_button_5_Template, 5, 5, "button", 70);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 3, "asm.customerList.page.page", i0.ɵɵpureFunction1(6, _c18, ctx_r2.currentPage + 1)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.maxPage > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.maxPage > 0);
  }
}
function CustomerListComponent_ng_template_42_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 67);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "asm.customerList.title"));
  }
}
function CustomerListComponent_ng_template_42_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "asm.customerList.title"));
  }
}
function CustomerListComponent_ng_template_42_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label");
    i0.ɵɵtemplate(1, CustomerListComponent_ng_template_42_span_1_Template, 3, 3, "span", 64)(2, CustomerListComponent_ng_template_42_span_2_Template, 3, 3, "span", 65);
    i0.ɵɵelementStart(3, "ng-select", 75);
    i0.ɵɵlistener("change", function CustomerListComponent_ng_template_42_Template_ng_select_change_3_listener() {
      i0.ɵɵrestoreView(_r34);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onChangeCustomerGroup());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function CustomerListComponent_ng_template_42_Template_ng_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r34);
      const ctx_r2 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r2.selectedUserGroupId, $event) || (ctx_r2.selectedUserGroupId = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const customerListsPage_r35 = ctx.customerListsPage;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yShowLabelOfSelect");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yShowLabelOfSelect");
    i0.ɵɵadvance();
    i0.ɵɵproperty("searchable", false)("clearable", false)("tabIndex", 0);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r2.selectedUserGroupId);
    i0.ɵɵproperty("items", customerListsPage_r35 == null ? null : customerListsPage_r35.userGroups)("cxNgSelectA11y", i0.ɵɵpureFunction1(8, _c19, ctx_r2.getGroupName(customerListsPage_r35, ctx_r2.selectedUserGroupId)));
  }
}
function CustomerListComponent_ng_template_44_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 76);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function CustomerListComponent_ng_template_44_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.closeModal("Cross click"));
    });
    i0.ɵɵelementStart(3, "span", 77);
    i0.ɵɵelement(4, "cx-icon", 58);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 3, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 5, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.CLOSE);
  }
}
function CustomerListComponent_ng_template_46_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 78);
    i0.ɵɵlistener("click", function CustomerListComponent_ng_template_46_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r37);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.createCustomer());
    });
    i0.ɵɵelement(1, "cx-icon", 58);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r2.iconTypes.USER_PLUS);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "asm.customerList.createCustomer"));
  }
}
var BIND_CART_DIALOG_ACTION;
(function (BIND_CART_DIALOG_ACTION) {
  BIND_CART_DIALOG_ACTION["CANCEL"] = "CANCEL";
  BIND_CART_DIALOG_ACTION["REPLACE"] = "REPLACE";
})(BIND_CART_DIALOG_ACTION || (BIND_CART_DIALOG_ACTION = {}));
class AsmBindCartDialogComponent {
  constructor(launchDialogService) {
    this.launchDialogService = launchDialogService;
    this.BIND_CART_ACTION = BIND_CART_DIALOG_ACTION;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
  }
  closeModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  static {
    this.ɵfac = function AsmBindCartDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmBindCartDialogComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmBindCartDialogComponent,
      selectors: [["cx-asm-bind-cart-dialog"]],
      standalone: false,
      decls: 20,
      vars: 19,
      consts: [["role", "dialog", "aria-labelledby", "asm-bind-cart-dialog-title", 1, "cx-asm-bind-cart-dialog", "cx-modal-container", "cx-asm-dialog", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["id", "asm-bind-cart-dialog-title", 1, "title", "modal-title"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "cx-dialog-item"], [1, "cx-dialog-footer", "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"]],
      template: function AsmBindCartDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function AsmBindCartDialogComponent_Template_div_esc_0_listener() {
            return ctx.closeModal(ctx.BIND_CART_ACTION.CANCEL);
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "h2", 3);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 4)(7, "div", 5)(8, "div", 6);
          i0.ɵɵtext(9);
          i0.ɵɵpipe(10, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(11, "div", 7)(12, "button", 8);
          i0.ɵɵpipe(13, "cxTranslate");
          i0.ɵɵlistener("click", function AsmBindCartDialogComponent_Template_button_click_12_listener() {
            return ctx.closeModal(ctx.BIND_CART_ACTION.REPLACE);
          });
          i0.ɵɵtext(14);
          i0.ɵɵpipe(15, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "button", 9);
          i0.ɵɵpipe(17, "cxTranslate");
          i0.ɵɵlistener("click", function AsmBindCartDialogComponent_Template_button_click_16_listener() {
            return ctx.closeModal(ctx.BIND_CART_ACTION.CANCEL);
          });
          i0.ɵɵtext(18);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "asm.bindCart.dialog.title"), " ");
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 9, "asm.bindCart.dialog.body"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(13, 11, "asm.bindCart.dialog.actions.replace"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 13, "asm.bindCart.dialog.actions.replace"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(17, 15, "common.cancel"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 17, "common.cancel"), " ");
        }
      },
      dependencies: [i1.FocusDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmBindCartDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-bind-cart-dialog',
      standalone: false,
      template: "<div\n  class=\"cx-asm-bind-cart-dialog cx-modal-container cx-asm-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"closeModal(BIND_CART_ACTION.CANCEL)\"\n  aria-labelledby=\"asm-bind-cart-dialog-title\"\n>\n  <div class=\"cx-modal-content\">\n    <!-- Modal Header -->\n    <div class=\"cx-dialog-header modal-header\">\n      <h2 id=\"asm-bind-cart-dialog-title\" class=\"title modal-title\">\n        {{ 'asm.bindCart.dialog.title' | cxTranslate }}\n      </h2>\n    </div>\n\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <div class=\"cx-dialog-row\">\n        <div class=\"cx-dialog-item\">\n          {{ 'asm.bindCart.dialog.body' | cxTranslate }}\n        </div>\n      </div>\n    </div>\n\n    <!-- Modal Footer -->\n    <div class=\"cx-dialog-footer modal-footer\">\n      <button\n        (click)=\"closeModal(BIND_CART_ACTION.REPLACE)\"\n        [attr.aria-label]=\"'asm.bindCart.dialog.actions.replace' | cxTranslate\"\n        class=\"btn btn-primary\"\n        type=\"button\"\n      >\n        {{ 'asm.bindCart.dialog.actions.replace' | cxTranslate }}\n      </button>\n\n      <button\n        (click)=\"closeModal(BIND_CART_ACTION.CANCEL)\"\n        [attr.aria-label]=\"'common.cancel' | cxTranslate\"\n        class=\"btn btn-secondary\"\n        type=\"button\"\n      >\n        {{ 'common.cancel' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SAVE_CART_DIALOG_ACTION;
(function (SAVE_CART_DIALOG_ACTION) {
  SAVE_CART_DIALOG_ACTION["CANCEL"] = "CANCEL";
  SAVE_CART_DIALOG_ACTION["SAVE"] = "SAVE";
})(SAVE_CART_DIALOG_ACTION || (SAVE_CART_DIALOG_ACTION = {}));
class AsmSaveCartDialogComponent {
  constructor(launchDialogService, savedCartFacade) {
    this.launchDialogService = launchDialogService;
    this.savedCartFacade = savedCartFacade;
    this.BIND_CART_ACTION = SAVE_CART_DIALOG_ACTION;
    this.showDialogAlert$ = new BehaviorSubject(true);
    this.globalMessageType = GlobalMessageType;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
    useFeatureStyles('a11yQTY2Quantity');
  }
  ngOnInit() {
    this.launchDialogService.data$.pipe(take(1)).subscribe(data => {
      this.cart = data;
      this.setCartTotalQty();
    });
  }
  setCartTotalQty() {
    let count = 0;
    if (this.cart.entries) {
      for (const entry of this.cart.entries) {
        count += entry.quantity ? entry.quantity : 0;
      }
    }
    this.cartQty = count;
  }
  closeDialogAlert() {
    this.showDialogAlert$.next(false);
  }
  closeModal(reason) {
    if (reason === SAVE_CART_DIALOG_ACTION.SAVE) {
      this.saveCart();
    }
    this.launchDialogService.closeDialog(reason);
  }
  saveCart() {
    this.savedCartFacade.saveCart({
      cartId: this.cart.code,
      saveCartName: this.cart.code,
      saveCartDescription: '-'
    });
  }
  static {
    this.ɵfac = function AsmSaveCartDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmSaveCartDialogComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i2.SavedCartFacade));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmSaveCartDialogComponent,
      selectors: [["cx-asm-save-cart-dialog"]],
      standalone: false,
      decls: 37,
      vars: 30,
      consts: [["showSaveCartWarning", ""], ["role", "dialog", "aria-labelledby", "asm-save-cart-dialog-title", 1, "cx-asm-save-cart-dialog", "cx-modal-container", "cx-asm-dialog", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["id", "asm-save-cart-dialog-title", 1, "title", "modal-title"], [1, "cx-dialog-body", "modal-body"], [4, "ngIf", "ngIfElse"], [1, "cx-dialog-content"], [1, "cx-dialog-row", "row"], [1, "cx-dialog-item", "col-sm-6", "col-md-6", "text-right", "item-left-text"], [1, "cx-dialog-item", "col-sm-6", "col-md-6", "text-left", "item-right-text"], ["class", "cx-dialog-item col-sm-6 col-md-6 text-right item-left-text", 4, "cxFeature"], [1, "cx-dialog-footer", "modal-footer"], ["id", "asm-save-cart-dialog-btn", "type", "button", 1, "btn", "btn-primary", 3, "click", "disabled"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "message-container"], [3, "text", "type", "closeMessage", 4, "ngIf"], [3, "closeMessage", "text", "type"]],
      template: function AsmSaveCartDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("esc", function AsmSaveCartDialogComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal(ctx.BIND_CART_ACTION.CANCEL));
          });
          i0.ɵɵelementStart(1, "div", 2)(2, "div", 3)(3, "h2", 4);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 5);
          i0.ɵɵtemplate(7, AsmSaveCartDialogComponent_ng_container_7_Template, 4, 3, "ng-container", 6)(8, AsmSaveCartDialogComponent_ng_template_8_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementStart(10, "div", 7)(11, "div", 8)(12, "div", 9);
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "div", 10);
          i0.ɵɵtext(16);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(17, "div", 8);
          i0.ɵɵtemplate(18, AsmSaveCartDialogComponent_div_18_Template, 3, 3, "div", 11)(19, AsmSaveCartDialogComponent_div_19_Template, 3, 3, "div", 11);
          i0.ɵɵelementStart(20, "div", 10);
          i0.ɵɵtext(21);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(22, "div", 8)(23, "div", 9);
          i0.ɵɵtext(24);
          i0.ɵɵpipe(25, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(26, "div", 10);
          i0.ɵɵtext(27);
          i0.ɵɵelementEnd()()()();
          i0.ɵɵelementStart(28, "div", 12)(29, "button", 13);
          i0.ɵɵpipe(30, "cxTranslate");
          i0.ɵɵlistener("click", function AsmSaveCartDialogComponent_Template_button_click_29_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal(ctx.BIND_CART_ACTION.SAVE));
          });
          i0.ɵɵtext(31);
          i0.ɵɵpipe(32, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(33, "button", 14);
          i0.ɵɵpipe(34, "cxTranslate");
          i0.ɵɵlistener("click", function AsmSaveCartDialogComponent_Template_button_click_33_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal(ctx.BIND_CART_ACTION.CANCEL));
          });
          i0.ɵɵtext(35);
          i0.ɵɵpipe(36, "cxTranslate");
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          const showSaveCartWarning_r5 = i0.ɵɵreference(9);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 16, "asm.saveCart.dialog.title"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.cartQty > 0)("ngIfElse", showSaveCartWarning_r5);
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 18, "asm.saveCart.dialog.row.id"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", ctx.cart.code, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxFeature", "a11yQTY2Quantity");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yQTY2Quantity");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.cartQty, " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 20, "asm.saveCart.dialog.row.total"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", ctx.cart.totalPriceWithTax == null ? null : ctx.cart.totalPriceWithTax.formattedValue, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("disabled", ctx.cartQty === 0);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(30, 22, "asm.saveCart.dialog.actions.save"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(32, 24, "asm.saveCart.dialog.actions.save"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(34, 26, "common.cancel"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(36, 28, "common.cancel"), " ");
        }
      },
      dependencies: [i5.NgIf, i1.FocusDirective, i1.MessageComponent, i1$1.FeatureDirective, i5.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmSaveCartDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-save-cart-dialog',
      standalone: false,
      template: "<div\n  class=\"cx-asm-save-cart-dialog cx-modal-container cx-asm-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"closeModal(BIND_CART_ACTION.CANCEL)\"\n  aria-labelledby=\"asm-save-cart-dialog-title\"\n>\n  <div class=\"cx-modal-content\">\n    <!-- Modal Header -->\n    <div class=\"cx-dialog-header modal-header\">\n      <h2 id=\"asm-save-cart-dialog-title\" class=\"title modal-title\">\n        {{ 'asm.saveCart.dialog.title' | cxTranslate }}\n      </h2>\n    </div>\n\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <ng-container *ngIf=\"cartQty > 0; else showSaveCartWarning\">\n        <div class=\"message-container\">\n          <cx-message\n            *ngIf=\"showDialogAlert$ | async\"\n            [text]=\"'asm.saveCart.dialog.saveInfo' | cxTranslate\"\n            [type]=\"globalMessageType.MSG_TYPE_INFO\"\n            (closeMessage)=\"closeDialogAlert()\"\n          >\n          </cx-message>\n        </div>\n      </ng-container>\n      <ng-template #showSaveCartWarning>\n        <div class=\"message-container\">\n          <cx-message\n            *ngIf=\"showDialogAlert$ | async\"\n            [text]=\"'asm.saveCart.dialog.disableInfo' | cxTranslate\"\n            [type]=\"globalMessageType.MSG_TYPE_WARNING\"\n            (closeMessage)=\"closeDialogAlert()\"\n          >\n          </cx-message>\n        </div>\n      </ng-template>\n\n      <div class=\"cx-dialog-content\">\n        <div class=\"cx-dialog-row row\">\n          <div\n            class=\"cx-dialog-item col-sm-6 col-md-6 text-right item-left-text\"\n          >\n            {{ 'asm.saveCart.dialog.row.id' | cxTranslate }}\n          </div>\n          <div\n            class=\"cx-dialog-item col-sm-6 col-md-6 text-left item-right-text\"\n          >\n            {{ cart.code }}\n          </div>\n        </div>\n        <div class=\"cx-dialog-row row\">\n          <div\n            *cxFeature=\"'a11yQTY2Quantity'\"\n            class=\"cx-dialog-item col-sm-6 col-md-6 text-right item-left-text\"\n          >\n            {{ 'asm.saveCart.dialog.row.qtyFull' | cxTranslate }}\n          </div>\n          <div\n            *cxFeature=\"'!a11yQTY2Quantity'\"\n            class=\"cx-dialog-item col-sm-6 col-md-6 text-right item-left-text\"\n          >\n            {{ 'asm.saveCart.dialog.row.qty' | cxTranslate }}\n          </div>\n          <div\n            class=\"cx-dialog-item col-sm-6 col-md-6 text-left item-right-text\"\n          >\n            {{ cartQty }}\n          </div>\n        </div>\n        <div class=\"cx-dialog-row row\">\n          <div\n            class=\"cx-dialog-item col-sm-6 col-md-6 text-right item-left-text\"\n          >\n            {{ 'asm.saveCart.dialog.row.total' | cxTranslate }}\n          </div>\n          <div\n            class=\"cx-dialog-item col-sm-6 col-md-6 text-left item-right-text\"\n          >\n            {{ cart.totalPriceWithTax?.formattedValue }}\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!-- Modal Footer -->\n    <div class=\"cx-dialog-footer modal-footer\">\n      <button\n        id=\"asm-save-cart-dialog-btn\"\n        (click)=\"closeModal(BIND_CART_ACTION.SAVE)\"\n        [attr.aria-label]=\"'asm.saveCart.dialog.actions.save' | cxTranslate\"\n        class=\"btn btn-primary\"\n        type=\"button\"\n        [disabled]=\"this.cartQty === 0\"\n      >\n        {{ 'asm.saveCart.dialog.actions.save' | cxTranslate }}\n      </button>\n\n      <button\n        (click)=\"closeModal(BIND_CART_ACTION.CANCEL)\"\n        [attr.aria-label]=\"'common.cancel' | cxTranslate\"\n        class=\"btn btn-secondary\"\n        type=\"button\"\n      >\n        {{ 'common.cancel' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }, {
    type: i2.SavedCartFacade
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AsmComponentService {
  constructor(authService, csAgentAuthService, winRef, asmEnablerService, asmDeepLinkService) {
    this.authService = authService;
    this.csAgentAuthService = csAgentAuthService;
    this.winRef = winRef;
    this.asmEnablerService = asmEnablerService;
    this.asmDeepLinkService = asmDeepLinkService;
    this.isEmulatedByDeepLink$ = new BehaviorSubject(false);
    this.showDeeplinkCartInfoAlert$ = new BehaviorSubject(false);
    this.routingService = inject(RoutingService);
  }
  /**
   * Returns a deep link parameter value if it is in the url.
   */
  getSearchParameter(key) {
    return this.asmDeepLinkService?.getSearchParameter(key);
  }
  isEmulatedByDeepLink() {
    return this.isEmulatedByDeepLink$;
  }
  setEmulatedByDeepLink(emulated) {
    this.isEmulatedByDeepLink$.next(emulated);
  }
  setShowDeeplinkCartInfoAlert(display) {
    this.showDeeplinkCartInfoAlert$.next(display);
  }
  shouldShowDeeplinkCartInfoAlert() {
    return this.showDeeplinkCartInfoAlert$;
  }
  logoutCustomerSupportAgentAndCustomer() {
    this.csAgentAuthService.logoutCustomerSupportAgent();
  }
  logoutCustomer() {
    this.authService.logout();
  }
  isCustomerEmulationSessionInProgress() {
    return this.csAgentAuthService.isCustomerEmulated();
  }
  /**
   * We're currently only removing the persisted storage in the browser
   * to ensure the ASM experience isn't loaded on the next visit. There are a few
   * optimizations we could think of:
   * - drop the `asm` parameter from the URL, in case it's still there
   * - remove the generated UI from the DOM (outlets currently do not support this)
   */
  unload() {
    if (this.winRef.localStorage) {
      this.winRef.localStorage.removeItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
    }
  }
  /**
   * check whether try to emulate customer from deeplink
   */
  isEmulateInURL() {
    return this.asmDeepLinkService?.isEmulateInURL() || false;
  }
  /**
   * Returns valid deep link parameters in the url.
   */
  getDeepLinkUrlParams() {
    return this.asmDeepLinkService?.getParamsInUrl();
  }
  /**
   * Handles the navigation based on deep link parameters in the URL
   * or passed parameter.
   */
  handleDeepLinkNavigation(parameters = this.getDeepLinkUrlParams()) {
    this.asmDeepLinkService?.handleNavigation(parameters);
  }
  handleAsmDialogAction(event) {
    if (typeof event === 'object' && event.actionType === AsmDialogActionType.NAVIGATE) {
      this.routingService.go(event.route);
    }
  }
  static {
    this.ɵfac = function AsmComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmComponentService)(i0.ɵɵinject(i1$1.AuthService), i0.ɵɵinject(i2$1.CsAgentAuthService), i0.ɵɵinject(i1$1.WindowRef), i0.ɵɵinject(i2$1.AsmEnablerService), i0.ɵɵinject(i2$1.AsmDeepLinkService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AsmComponentService,
      factory: AsmComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.AuthService
  }, {
    type: i2$1.CsAgentAuthService
  }, {
    type: i1$1.WindowRef
  }, {
    type: i2$1.AsmEnablerService
  }, {
    type: i2$1.AsmDeepLinkService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class DotSpinnerComponent {
  static {
    this.ɵfac = function DotSpinnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DotSpinnerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DotSpinnerComponent,
      selectors: [["cx-dot-spinner"]],
      standalone: false,
      decls: 3,
      vars: 0,
      template: function DotSpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div")(1, "div")(2, "div");
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotSpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-dot-spinner',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div></div>\n<div></div>\n<div></div>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AsmBindCartComponent {
  constructor(globalMessageService, activeCartFacade, multiCartFacade, asmBindCartFacade, launchDialogService, savedCartFacade, asmComponentService, routing) {
    this.globalMessageService = globalMessageService;
    this.activeCartFacade = activeCartFacade;
    this.multiCartFacade = multiCartFacade;
    this.asmBindCartFacade = asmBindCartFacade;
    this.launchDialogService = launchDialogService;
    this.savedCartFacade = savedCartFacade;
    this.asmComponentService = asmComponentService;
    this.routing = routing;
    this.activeCartValidator = control => {
      if (control.value === this.activeCartId) {
        return {
          activeCartError: true
        };
      }
      if (!!this.deepLinkCartId && control.value !== this.deepLinkCartId) {
        this.resetDeeplinkCart();
      }
      return null;
    };
    this.cartId = new FormControl('', [Validators.required, Validators.minLength(1), this.activeCartValidator]);
    this.loading$ = new BehaviorSubject(false);
    this.valid$ = this.cartId.statusChanges.pipe(map(status => status === 'VALID'), shareReplay(1));
    this.activeCartId = '';
    this.deepLinkCartId = '';
    this.displayBindCartBtn$ = new BehaviorSubject(true);
    this.displaySaveCartBtn$ = new BehaviorSubject(false);
    this.subscription = new Subscription();
    this.featureConfig = inject(FeatureConfigService);
    this.isShowStyleChangesInASM = this.featureConfig.isEnabled('showStyleChangesInASM');
  }
  ngOnInit() {
    this.subscribeForDeeplinkCart();
    this.subscription.add(this.activeCartFacade.getActiveCartId().subscribe(response => {
      this.activeCartId = response ?? '';
    }));
  }
  /**
   * Bind the input cart number to the customer
   */
  bindCartToCustomer() {
    const anonymousCartId = this.cartId.value;
    const subscription = combineLatest([this.loading$.asObservable(), this.valid$]).pipe(take(1), filter(([loading, valid]) => !loading && valid), tap(() => this.loading$.next(true)), concatMap(() => this.activeCartFacade.getActive().pipe(map(cart => cart.deliveryItemsQuantity ?? 0), take(1))), concatMap(cartItemCount => iif(() => Boolean(this.activeCartId && cartItemCount), this.openDialog(this.activeCartId, anonymousCartId), this.simpleBindCart(anonymousCartId))), finalize(() => this.loading$.next(false))).subscribe({
      next: () => {
        this.globalMessageService.add({
          key: 'asm.bindCart.success'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      },
      error: error => {
        this.globalMessageService.add(error.details?.[0].message ?? '', GlobalMessageType.MSG_TYPE_ERROR);
      }
    });
    this.subscription.add(subscription);
  }
  onSaveInactiveCart() {
    this.asmComponentService?.setShowDeeplinkCartInfoAlert(false);
    const customerId = this.asmComponentService?.getSearchParameter('customerId');
    this.multiCartFacade.loadCart({
      cartId: this.deepLinkCartId,
      userId: customerId
    });
    this.multiCartFacade.getCartEntity(this.deepLinkCartId).pipe(filter(state => state.loading === false && state.success === true), take(1), map(state => state.value), filter(cart => !!cart)).subscribe(cart => {
      this.openASMSaveCartDialog(cart);
    });
    this.afterCloseASMSaveCartDialog();
  }
  clearText() {
    this.cartId.setValue('');
    this.resetDeeplinkCart();
  }
  resetDeeplinkCart() {
    this.deepLinkCartId = '';
    this.displayBindCartBtn$.next(true);
    this.displaySaveCartBtn$.next(false);
    this.asmComponentService?.setShowDeeplinkCartInfoAlert(false);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  /**
   * Binds cart on subscription and reloads cart
   */
  simpleBindCart(anonymousCartId) {
    return defer(() => this.asmBindCartFacade.bindCart(anonymousCartId)).pipe(tap(() => this.multiCartFacade.reloadCart(OCC_CART_ID_CURRENT)));
  }
  /**
   * Opens dialog and passes non-cancel result to select action
   */
  openDialog(activeCartId, anonymousCartId) {
    return defer(() => {
      this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ASM_BIND_CART, this.bindToCartElemRef);
      return this.launchDialogService.dialogClose.pipe(filter(result => Boolean(result)), take(1));
    }).pipe(filter(dialogResult => Boolean(dialogResult)), concatMap(dialogResult => {
      return this.selectBindAction(activeCartId, anonymousCartId, dialogResult);
    }));
  }
  selectBindAction(activeCartId, anonymousCartId, action) {
    switch (action) {
      case BIND_CART_DIALOG_ACTION.REPLACE:
        return this.replaceCart(activeCartId, anonymousCartId);
      case BIND_CART_DIALOG_ACTION.CANCEL:
      default:
        return EMPTY;
    }
  }
  replaceCart(previousActiveCartId, anonymousCartId) {
    return this.simpleBindCart(anonymousCartId).pipe(tap(() => {
      this.savedCartFacade.saveCart({
        cartId: previousActiveCartId,
        saveCartName: previousActiveCartId,
        // TODO(#12660): Remove default value once backend is updated
        saveCartDescription: '-'
      });
    }));
  }
  subscribeForDeeplinkCart() {
    this.subscription.add(this.asmComponentService?.isEmulatedByDeepLink().pipe(filter(emulated => emulated && !!this.asmComponentService?.getSearchParameter('cartId'))).subscribe(() => {
      const cartType = this.asmComponentService?.getSearchParameter('cartType');
      if (cartType === 'inactive' || cartType === 'active') {
        this.displayBindCartBtn$.next(false);
        this.displaySaveCartBtn$.next(cartType === 'inactive');
        this.deepLinkCartId = this.asmComponentService?.getSearchParameter('cartId');
        if (cartType === 'inactive') {
          this.cartId.setValue(this.deepLinkCartId);
        }
        this.asmComponentService?.setShowDeeplinkCartInfoAlert(true);
        this.asmComponentService?.handleDeepLinkNavigation();
      }
    }));
  }
  openASMSaveCartDialog(inactiveCart) {
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ASM_SAVE_CART, this.saveInactiveCartElemRef, inactiveCart);
  }
  afterCloseASMSaveCartDialog() {
    this.launchDialogService.dialogClose.pipe(filter(result => result === SAVE_CART_DIALOG_ACTION.SAVE), take(1), tap(() => this.loading$.next(true))).subscribe();
    this.savedCartFacade.getSaveCartProcessSuccess().pipe(filter(success => success), take(1), tap(() => this.loading$.next(false))).subscribe(() => {
      this.goToSavedCartDetails(this.deepLinkCartId);
      this.displaySaveCartBtn$.next(false);
    });
    this.savedCartFacade.getSaveCartProcessError().pipe(filter(error => error), take(1), tap(() => this.loading$.next(false))).subscribe();
  }
  goToSavedCartDetails(cartId) {
    this.routing?.go({
      cxRoute: 'savedCartsDetails',
      params: {
        savedCartId: cartId
      }
    });
  }
  static {
    this.ɵfac = function AsmBindCartComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmBindCartComponent)(i0.ɵɵdirectiveInject(i1$1.GlobalMessageService), i0.ɵɵdirectiveInject(i2$2.ActiveCartFacade), i0.ɵɵdirectiveInject(i2$2.MultiCartFacade), i0.ɵɵdirectiveInject(i2$1.AsmBindCartFacade), i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i2.SavedCartFacade), i0.ɵɵdirectiveInject(AsmComponentService), i0.ɵɵdirectiveInject(i1$1.RoutingService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmBindCartComponent,
      selectors: [["cx-asm-bind-cart"]],
      viewQuery: function AsmBindCartComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.bindToCartElemRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.saveInactiveCartElemRef = _t.first);
        }
      },
      standalone: false,
      decls: 15,
      vars: 25,
      consts: [["cartIdElement", ""], ["bindToCart", ""], ["saveInactiveCart", ""], ["for", "cartNumber"], ["role", "search", 3, "click", "ngClass"], ["autocomplete", "off", "formcontrolname", "cartNumber", 3, "keydown.enter", "formControl"], ["class", "cx-asm-reset", 3, "visible", "click", 4, "ngIf"], ["class", "cx-asm-bindCartToCustomer", "type", "submit", 3, "disabled", "cx-asm-active", "cx-bind-loading", "click", 4, "ngIf"], ["id", "asm-save-inactive-cart-btn", "class", "cx-asm-bindCartToCustomer cx-asm-active", "type", "submit", 3, "cx-bind-loading", "click", 4, "ngIf"], [1, "cx-asm-reset", 3, "click"], [1, "cx-icon", "fas", "fa-times-circle"], ["type", "submit", 1, "cx-asm-bindCartToCustomer", 3, "click", "disabled"], ["id", "asm-save-inactive-cart-btn", "type", "submit", 1, "cx-asm-bindCartToCustomer", "cx-asm-active", 3, "click"]],
      template: function AsmBindCartComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "form")(1, "label", 3);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "div", 4);
          i0.ɵɵpipe(5, "async");
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵlistener("click", function AsmBindCartComponent_Template_div_click_4_listener() {
            i0.ɵɵrestoreView(_r1);
            const cartIdElement_r2 = i0.ɵɵreference(8);
            return i0.ɵɵresetView(cartIdElement_r2.focus());
          });
          i0.ɵɵelementStart(7, "input", 5, 0);
          i0.ɵɵpipe(9, "cxTranslate");
          i0.ɵɵlistener("keydown.enter", function AsmBindCartComponent_Template_input_keydown_enter_7_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.bindCartToCustomer());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, AsmBindCartComponent_button_10_Template, 4, 8, "button", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, AsmBindCartComponent_button_11_Template, 12, 23, "button", 7);
          i0.ɵɵpipe(12, "async");
          i0.ɵɵtemplate(13, AsmBindCartComponent_button_13_Template, 10, 16, "button", 8);
          i0.ɵɵpipe(14, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 10, "asm.bindCart.cartNumber"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵclassProp("active", i0.ɵɵpipeBind1(5, 12, ctx.valid$));
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(22, _c2, !ctx.isShowStyleChangesInASM, ctx.isShowStyleChangesInASM));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 14, "asm.bindCart.assignCartId"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("formControl", ctx.cartId);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(9, 16, "asm.bindCart.enterCartId"));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", !ctx.isShowStyleChangesInASM);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 18, ctx.displayBindCartBtn$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(14, 20, ctx.displaySaveCartBtn$));
        }
      },
      dependencies: [i5.NgClass, i5.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.FormControlDirective, i1.IconComponent, i1$2.NgForm, DotSpinnerComponent, i5.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmBindCartComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-bind-cart',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<form>\n  <label for=\"cartNumber\">{{ 'asm.bindCart.cartNumber' | cxTranslate }} </label>\n  <div\n    role=\"search\"\n    [attr.aria-label]=\"'asm.bindCart.assignCartId' | cxTranslate\"\n    [ngClass]=\"{\n      'cx-asm-assignCart': !isShowStyleChangesInASM,\n      'cx-asm-assignCart-input-show-no-button': isShowStyleChangesInASM,\n    }\"\n    [class.active]=\"valid$ | async\"\n    (click)=\"cartIdElement.focus()\"\n  >\n    <input\n      autocomplete=\"off\"\n      #cartIdElement\n      formcontrolname=\"cartNumber\"\n      [formControl]=\"cartId\"\n      (keydown.enter)=\"bindCartToCustomer()\"\n      [attr.aria-label]=\"'asm.bindCart.enterCartId' | cxTranslate\"\n    />\n    <button\n      *ngIf=\"!isShowStyleChangesInASM\"\n      class=\"cx-asm-reset\"\n      [attr.title]=\"'asm.bindCart.resetCartId' | cxTranslate\"\n      [attr.aria-label]=\"'asm.bindCart.resetCartId' | cxTranslate\"\n      [class.visible]=\"cartId.value?.length > 0\"\n      (click)=\"clearText()\"\n    >\n      <cx-icon class=\"cx-icon fas fa-times-circle\"></cx-icon>\n    </button>\n  </div>\n  <button\n    #bindToCart\n    *ngIf=\"displayBindCartBtn$ | async\"\n    class=\"cx-asm-bindCartToCustomer\"\n    [disabled]=\"!(valid$ | async)\"\n    type=\"submit\"\n    [class.cx-asm-active]=\"valid$ | async\"\n    [class.cx-bind-loading]=\"loading$ | async\"\n    (click)=\"bindCartToCustomer()\"\n  >\n    <span [attr.aria-hidden]=\"loading$ | async\">\n      {{ 'asm.bindCart.bindCartToCustomer' | cxTranslate }}\n    </span>\n    <cx-dot-spinner\n      [attr.aria-hidden]=\"!(loading$ | async)\"\n      [attr.aria-label]=\"'common.loading' | cxTranslate\"\n    ></cx-dot-spinner>\n  </button>\n\n  <button\n    id=\"asm-save-inactive-cart-btn\"\n    #saveInactiveCart\n    *ngIf=\"displaySaveCartBtn$ | async\"\n    class=\"cx-asm-bindCartToCustomer cx-asm-active\"\n    type=\"submit\"\n    [class.cx-bind-loading]=\"loading$ | async\"\n    (click)=\"onSaveInactiveCart()\"\n  >\n    <span [attr.aria-hidden]=\"loading$ | async\">\n      {{ 'asm.saveCart.saveCartBtn' | cxTranslate }}\n    </span>\n    <cx-dot-spinner\n      [attr.aria-hidden]=\"!(loading$ | async)\"\n      [attr.aria-label]=\"'common.loading' | cxTranslate\"\n    ></cx-dot-spinner>\n  </button>\n</form>\n"
    }]
  }], () => [{
    type: i1$1.GlobalMessageService
  }, {
    type: i2$2.ActiveCartFacade
  }, {
    type: i2$2.MultiCartFacade
  }, {
    type: i2$1.AsmBindCartFacade
  }, {
    type: i1.LaunchDialogService
  }, {
    type: i2.SavedCartFacade
  }, {
    type: AsmComponentService
  }, {
    type: i1$1.RoutingService
  }], {
    bindToCartElemRef: [{
      type: ViewChild,
      args: ['bindToCart']
    }],
    saveInactiveCartElemRef: [{
      type: ViewChild,
      args: ['saveInactiveCart']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AsmCreateCustomerFormComponent {
  constructor(launchDialogService, fb, asmCreateCustomerFacade, translationService) {
    this.launchDialogService = launchDialogService;
    this.fb = fb;
    this.asmCreateCustomerFacade = asmCreateCustomerFacade;
    this.translationService = translationService;
    this.iconTypes = ICON_TYPE;
    this.isLoading$ = new BehaviorSubject(false);
    this.showDialogInfoAlert = true;
    this.globalMessageType = GlobalMessageType;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
    this.registerForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, CustomFormValidators.emailValidator]]
    });
  }
  submitForm() {
    if (this.registerForm.valid) {
      this.registerUser();
    } else {
      this.registerForm.markAllAsTouched();
    }
  }
  registerUser() {
    this.isLoading$.next(true);
    const {
      firstName,
      lastName,
      email
    } = this.registerForm.value;
    this.createdCustomer = {
      firstName: firstName ?? '',
      lastName: lastName ?? '',
      email: email ?? ''
    };
    const obs$ = this.asmCreateCustomerFacade.createCustomer(this.collectDataFromRegisterForm());
    obs$.subscribe({
      next: result => this.onRegisterUserSuccess(result),
      error: error => this.onRegisterUserFail(error)
    });
    obs$.subscribe({
      complete: () => this.isLoading$.next(false)
    });
  }
  collectDataFromRegisterForm() {
    return {
      firstName: this.createdCustomer.firstName,
      lastName: this.createdCustomer.lastName,
      emailAddress: this.createdCustomer.email
    };
  }
  closeModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  closeDialogInfoAlert() {
    this.showDialogInfoAlert = false;
  }
  closeDialogBackendErroAlert(index) {
    this.showDialogBackendErrorAlerts[index] = false;
  }
  onRegisterUserSuccess(user) {
    this.launchDialogService.closeDialog(user);
  }
  onRegisterUserFail(error) {
    this.isLoading$.next(false);
    this.backendErrorMessages = [];
    this.showDialogBackendErrorAlerts = [];
    const unknownError = 'httpHandlers.unknownError';
    const errorDetails = error.details ?? [];
    if (errorDetails.length === 0) {
      this.addErrorMessage(unknownError);
    }
    errorDetails.forEach(errorDetail => {
      switch (errorDetail.type || '') {
        case 'ValidationError':
          this.addErrorMessage(`asm.createCustomerForm.validationErrors.${errorDetail.subject}`);
          break;
        case 'AssistedServiceDuplicatedUidError':
          this.addErrorMessage('asm.createCustomerForm.badRequestDuplicatedEmail', {
            emailAddress: this.createdCustomer.email
          });
          break;
        default:
          this.addErrorMessage(unknownError);
      }
    });
  }
  addErrorMessage(key, options) {
    this.translationService.translate(key, options).pipe(first()).subscribe(text => {
      this.backendErrorMessages.push(text);
      this.showDialogBackendErrorAlerts.push(true);
    });
  }
  static {
    this.ɵfac = function AsmCreateCustomerFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmCreateCustomerFormComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i1$2.FormBuilder), i0.ɵɵdirectiveInject(i2$1.AsmCreateCustomerFacade), i0.ɵɵdirectiveInject(i1$1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmCreateCustomerFormComponent,
      selectors: [["cx-asm-create-customer-form"]],
      standalone: false,
      decls: 23,
      vars: 17,
      consts: [["loading", ""], ["role", "dialog", "aria-labelledby", "asm-create-customer-form-title", 1, "cx-modal-container", "cx-asm-dialog", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [3, "ngSubmit", "formGroup"], [1, "cx-dialog-header", "modal-header"], ["id", "asm-create-customer-form-title", 1, "title", "modal-title"], [1, "cx-dialog-body", "modal-body"], [1, "message-container"], [3, "text", "type", "closeMessage", 4, "ngIf"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfElse"], [1, "modal-footer"], ["type", "submit", 1, "btn", "cx-asm-create-customer-btn", "cx-asm-create-customer-btn-create"], ["type", "button", 1, "btn", "cx-asm-create-customer-btn", "cx-asm-create-customer-btn-cancel", 3, "click"], [3, "closeMessage", "text", "type"], [1, "form-group"], [1, "label-content"], ["required", "true", "formControlName", "firstName", "name", "text", 1, "form-control", 3, "placeholder"], ["id", "firstNameError", 3, "control"], ["required", "true", "name", "text", "formControlName", "lastName", 1, "form-control", 3, "placeholder"], ["id", "lastNameError", 3, "control"], ["required", "true", "name", "email", "formControlName", "email", 1, "form-control", 3, "placeholder"], ["id", "emailError", 3, "control"], [1, "cx-spinner"]],
      template: function AsmCreateCustomerFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("esc", function AsmCreateCustomerFormComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal("Escape clicked"));
          });
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵelementContainerStart(2);
          i0.ɵɵelementStart(3, "form", 3);
          i0.ɵɵlistener("ngSubmit", function AsmCreateCustomerFormComponent_Template_form_ngSubmit_3_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.submitForm());
          });
          i0.ɵɵelementStart(4, "div", 4)(5, "h2", 5);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(8, "div", 6)(9, "div", 7);
          i0.ɵɵtemplate(10, AsmCreateCustomerFormComponent_cx_message_10_Template, 2, 4, "cx-message", 8)(11, AsmCreateCustomerFormComponent_ng_container_11_Template, 2, 1, "ng-container", 9);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(12, AsmCreateCustomerFormComponent_div_12_Template, 25, 27, "div", 10);
          i0.ɵɵpipe(13, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(14, "div", 11)(15, "button", 12);
          i0.ɵɵtext(16);
          i0.ɵɵpipe(17, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(18, "button", 13);
          i0.ɵɵlistener("click", function AsmCreateCustomerFormComponent_Template_button_click_18_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal("Cancel click"));
          });
          i0.ɵɵtext(19);
          i0.ɵɵpipe(20, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(21, AsmCreateCustomerFormComponent_ng_template_21_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const loading_r7 = i0.ɵɵreference(22);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("formGroup", ctx.registerForm);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "asm.createCustomerForm.title"), " ");
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.showDialogInfoAlert);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.backendErrorMessages);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(13, 11, ctx.isLoading$))("ngIfElse", loading_r7);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 13, "asm.createCustomerForm.createAccount"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(20, 15, "asm.createCustomerForm.cancel"), " ");
        }
      },
      dependencies: [i5.NgForOf, i5.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.RequiredValidator, i1$2.FormGroupDirective, i1$2.FormControlName, i1.FormErrorsComponent, i1.SpinnerComponent, i1.FocusDirective, i1.MessageComponent, i5.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmCreateCustomerFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-create-customer-form',
      standalone: false,
      template: "<div\n  class=\"cx-modal-container cx-asm-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"closeModal('Escape clicked')\"\n  aria-labelledby=\"asm-create-customer-form-title\"\n>\n  <div class=\"cx-modal-content\">\n    <ng-container>\n      <form (ngSubmit)=\"submitForm()\" [formGroup]=\"registerForm\">\n        <!-- Modal Header -->\n        <div class=\"cx-dialog-header modal-header\">\n          <h2 id=\"asm-create-customer-form-title\" class=\"title modal-title\">\n            {{ 'asm.createCustomerForm.title' | cxTranslate }}\n          </h2>\n        </div>\n        <!-- Modal Body -->\n        <div class=\"cx-dialog-body modal-body\">\n          <div class=\"message-container\">\n            <cx-message\n              *ngIf=\"showDialogInfoAlert\"\n              [text]=\"'asm.createCustomerForm.createAccountAlert' | cxTranslate\"\n              [type]=\"globalMessageType.MSG_TYPE_INFO\"\n              (closeMessage)=\"closeDialogInfoAlert()\"\n            >\n            </cx-message>\n            <ng-container\n              *ngFor=\"let errorMessage of backendErrorMessages; let i = index\"\n            >\n              <cx-message\n                *ngIf=\"showDialogBackendErrorAlerts[i]\"\n                [text]=\"errorMessage\"\n                [type]=\"globalMessageType.MSG_TYPE_ERROR\"\n                (closeMessage)=\"closeDialogBackendErroAlert(i)\"\n              >\n              </cx-message>\n            </ng-container>\n          </div>\n\n          <div *ngIf=\"!(isLoading$ | async); else loading\">\n            <div class=\"form-group\">\n              <label>\n                <span class=\"label-content\">{{\n                  'asm.createCustomerForm.firstName.label' | cxTranslate\n                }}</span>\n                <input\n                  required=\"true\"\n                  class=\"form-control\"\n                  placeholder=\"{{\n                    'asm.createCustomerForm.firstName.placeholder' | cxTranslate\n                  }}\"\n                  [attr.aria-invalid]=\"\n                    registerForm.get('firstName')?.touched &&\n                    registerForm.get('firstName')?.invalid\n                  \"\n                  [attr.aria-errormessage]=\"'firstNameError'\"\n                  formControlName=\"firstName\"\n                  name=\"text\"\n                />\n                <cx-form-errors\n                  id=\"firstNameError\"\n                  [control]=\"registerForm.get('firstName')\"\n                ></cx-form-errors>\n              </label>\n            </div>\n\n            <div class=\"form-group\">\n              <label>\n                <span class=\"label-content\">{{\n                  'asm.createCustomerForm.lastName.label' | cxTranslate\n                }}</span>\n                <input\n                  required=\"true\"\n                  class=\"form-control\"\n                  placeholder=\"{{\n                    'asm.createCustomerForm.lastName.placeholder' | cxTranslate\n                  }}\"\n                  [attr.aria-invalid]=\"\n                    registerForm.get('lastName')?.touched &&\n                    registerForm.get('lastName')?.invalid\n                  \"\n                  [attr.aria-errormessage]=\"'lastNameError'\"\n                  name=\"text\"\n                  formControlName=\"lastName\"\n                />\n                <cx-form-errors\n                  id=\"lastNameError\"\n                  [control]=\"registerForm.get('lastName')\"\n                ></cx-form-errors>\n              </label>\n            </div>\n\n            <div class=\"form-group\">\n              <label>\n                <span class=\"label-content\">{{\n                  'asm.createCustomerForm.emailAddress.label' | cxTranslate\n                }}</span>\n                <input\n                  required=\"true\"\n                  class=\"form-control\"\n                  placeholder=\"{{\n                    'asm.createCustomerForm.emailAddress.placeholder'\n                      | cxTranslate\n                  }}\"\n                  [attr.aria-invalid]=\"\n                    registerForm.get('email')?.touched &&\n                    registerForm.get('email')?.invalid\n                  \"\n                  [attr.aria-errormessage]=\"'emailError'\"\n                  name=\"email\"\n                  formControlName=\"email\"\n                />\n                <cx-form-errors\n                  id=\"emailError\"\n                  [control]=\"registerForm.get('email')\"\n                ></cx-form-errors>\n              </label>\n            </div>\n          </div>\n        </div>\n        <!-- Modal Footer -->\n        <div class=\"modal-footer\">\n          <button\n            type=\"submit\"\n            class=\"btn cx-asm-create-customer-btn cx-asm-create-customer-btn-create\"\n          >\n            {{ 'asm.createCustomerForm.createAccount' | cxTranslate }}\n          </button>\n          <button\n            type=\"button\"\n            class=\"btn cx-asm-create-customer-btn cx-asm-create-customer-btn-cancel\"\n            (click)=\"closeModal('Cancel click')\"\n          >\n            {{ 'asm.createCustomerForm.cancel' | cxTranslate }}\n          </button>\n        </div>\n      </form>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template #loading>\n  <div class=\"cx-spinner\"><cx-spinner></cx-spinner></div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }, {
    type: i1$2.FormBuilder
  }, {
    type: i2$1.AsmCreateCustomerFacade
  }, {
    type: i1$1.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultAsmCreateCustomerFormLayoutConfig = {
  launch: {
    ASM_CREATE_CUSTOMER_FORM: {
      inlineRoot: true,
      component: AsmCreateCustomerFormComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CSAgentLoginFormComponent {
  constructor(fb) {
    this.fb = fb;
    this.csAgentTokenLoading = false;
    this.submitEvent = new EventEmitter();
    useFeatureStyles('a11yPasswordVisibliltyBtnValueOverflow');
    useFeatureStyles('a11yTextSpacingAdjustments');
  }
  ngOnInit() {
    this.csAgentLoginForm = this.fb.group({
      userId: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }
  onSubmit() {
    if (this.csAgentLoginForm.valid) {
      this.submitEvent.emit({
        userId: this.csAgentLoginForm.get('userId')?.value,
        password: this.csAgentLoginForm.get('password')?.value
      });
    } else {
      this.csAgentLoginForm.markAllAsTouched();
    }
  }
  static {
    this.ɵfac = function CSAgentLoginFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CSAgentLoginFormComponent)(i0.ɵɵdirectiveInject(i1$2.UntypedFormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CSAgentLoginFormComponent,
      selectors: [["cx-csagent-login-form"]],
      inputs: {
        csAgentTokenLoading: "csAgentTokenLoading"
      },
      outputs: {
        submitEvent: "submitEvent"
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [[3, "formGroup", "ngSubmit", 4, "ngIf"], ["aria-hidden", "false", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "text", "formControlName", "userId"], ["id", "userIdError", 3, "translationParams", "control"], ["required", "true", "type", "password", "formControlName", "password", "cxPasswordVisibilitySwitch", ""], ["id", "passwordError", 3, "translationParams", "control"], ["type", "submit"], ["aria-hidden", "false"]],
      template: function CSAgentLoginFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CSAgentLoginFormComponent_form_0_Template, 20, 32, "form", 0)(1, CSAgentLoginFormComponent_cx_dot_spinner_1_Template, 2, 3, "cx-dot-spinner", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !ctx.csAgentTokenLoading);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.csAgentTokenLoading);
        }
      },
      dependencies: [i5.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.RequiredValidator, i1$2.FormGroupDirective, i1$2.FormControlName, i1.FormErrorsComponent, i1.PasswordVisibilityToggleDirective, DotSpinnerComponent, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CSAgentLoginFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-csagent-login-form',
      standalone: false,
      template: "<form\n  (ngSubmit)=\"onSubmit()\"\n  [formGroup]=\"csAgentLoginForm\"\n  *ngIf=\"!csAgentTokenLoading\"\n>\n  <span class=\"label-content\">\n    {{ 'asm.loginForm.userId.label' | cxTranslate }}\n  </span>\n  <label>\n    <input\n      required=\"true\"\n      type=\"text\"\n      formControlName=\"userId\"\n      [attr.aria-label]=\"'asm.loginForm.userId.label' | cxTranslate\"\n      [attr.aria-invalid]=\"\n        csAgentLoginForm.get('userId')?.touched &&\n        csAgentLoginForm.get('userId')?.invalid\n      \"\n      [attr.aria-errormessage]=\"'userIdError'\"\n    />\n\n    <cx-form-errors\n      id=\"userIdError\"\n      [translationParams]=\"{\n        label: 'asm.loginForm.userId.label' | cxTranslate,\n      }\"\n      [control]=\"csAgentLoginForm.get('userId')\"\n    ></cx-form-errors>\n  </label>\n\n  <span class=\"label-content\">\n    {{ 'asm.loginForm.password.label' | cxTranslate }}\n  </span>\n  <label>\n    <input\n      required=\"true\"\n      type=\"password\"\n      formControlName=\"password\"\n      [attr.aria-label]=\"'asm.loginForm.password.label' | cxTranslate\"\n      [attr.aria-invalid]=\"\n        csAgentLoginForm.get('password')?.touched &&\n        csAgentLoginForm.get('password')?.invalid\n      \"\n      [attr.aria-errormessage]=\"'passwordError'\"\n      cxPasswordVisibilitySwitch\n    />\n\n    <cx-form-errors\n      id=\"passwordError\"\n      [translationParams]=\"{\n        label: 'asm.loginForm.password.label' | cxTranslate,\n      }\"\n      [control]=\"csAgentLoginForm.get('password')\"\n    ></cx-form-errors>\n  </label>\n  <button type=\"submit\">\n    {{ 'asm.loginForm.submit' | cxTranslate }}\n  </button>\n</form>\n\n<cx-dot-spinner\n  *ngIf=\"csAgentTokenLoading\"\n  aria-hidden=\"false\"\n  [attr.aria-label]=\"'common.loading' | cxTranslate\"\n></cx-dot-spinner>\n"
    }]
  }], () => [{
    type: i1$2.UntypedFormBuilder
  }], {
    csAgentTokenLoading: [{
      type: Input
    }],
    submitEvent: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CustomerSelectionComponent {
  constructor(fb, asmService, config, directionService, launchDialogService) {
    this.fb = fb;
    this.asmService = asmService;
    this.config = config;
    this.directionService = directionService;
    this.launchDialogService = launchDialogService;
    this.subscription = new Subscription();
    this.searchByCustomer = false;
    this.searchByOrder = false;
    this.isLoading = false;
    this.activeFocusedButtonIndex = -1;
    this.featureConfig = inject(FeatureConfigService);
    this.isShowSearchingCustomerByOrderInASM = this.featureConfig.isEnabled('showSearchingCustomerByOrderInASM');
    this.submitEvent = new EventEmitter();
    useFeatureStyles('showSearchingCustomerByOrderInASM');
  }
  ngOnInit() {
    if (this.isShowSearchingCustomerByOrderInASM) {
      this.customerSelectionForm = this.fb.group({
        searchTerm: '',
        searchOrder: ''
      });
      this.subscription.add(this.customerSelectionForm.controls.searchOrder.valueChanges.pipe(debounceTime(300)).subscribe(searchTermValue => {
        this.searchByCustomer = false;
        this.searchByOrder = true;
        this.handleSearchByOrder(searchTermValue);
      }));
    } else {
      this.customerSelectionForm = this.fb.group({
        searchTerm: ['', Validators.required]
      });
    }
    this.asmService.customerSearchReset();
    this.searchResultsLoading$ = this.asmService.getCustomerSearchResultsLoading();
    this.searchResults = this.asmService.getCustomerSearchResults();
    this.subscription.add(this.customerSelectionForm.controls.searchTerm.valueChanges.pipe(debounceTime(300)).subscribe(searchTermValue => {
      if (this.isShowSearchingCustomerByOrderInASM) {
        this.searchByCustomer = true;
        this.searchByOrder = false;
        this.handleSearchByCustomer(searchTermValue);
      } else {
        this.handleSearchTerm(searchTermValue);
      }
    }));
    this.subscription.add(this.searchResultsLoading$.subscribe(loading => {
      this.isLoading = loading;
    }));
  }
  handleSearchTerm(searchTermValue) {
    if (!!this.selectedCustomer && searchTermValue !== this.selectedCustomer.name) {
      this.selectedCustomer = undefined;
    }
    if (Boolean(this.selectedCustomer)) {
      return;
    }
    this.asmService.customerSearchReset();
    this.activeFocusedButtonIndex = -1;
    if (searchTermValue.trim().length >= 3) {
      this.asmService.customerSearch({
        query: searchTermValue,
        pageSize: this.config.asm?.customerSearch?.maxResults
      });
    }
  }
  handleSearchByCustomer(searchTermValue) {
    if (!!this.selectedCustomer) {
      this.selectedCustomer = undefined;
    }
    if (!!this.customerSelectionForm.controls.searchOrder.value) {
      this.customerSelectionForm.controls.searchOrder.setValue(undefined, {
        emitEvent: false
      });
    }
    this.asmService.customerSearchReset();
    this.activeFocusedButtonIndex = -1;
    if (searchTermValue.trim().length >= 3) {
      this.asmService.customerSearch({
        query: searchTermValue,
        pageSize: this.config.asm?.customerSearch?.maxResults
      });
    }
  }
  handleSearchByOrder(searchOrderValue) {
    if (!!this.selectedCustomer) {
      this.selectedCustomer = undefined;
    }
    if (!!this.customerSelectionForm.controls.searchTerm.value) {
      this.customerSelectionForm.controls.searchTerm.setValue(undefined, {
        emitEvent: false
      });
    }
    this.asmService.customerSearchReset();
    this.activeFocusedButtonIndex = -1;
    if (searchOrderValue.trim().length >= 3) {
      this.asmService.customerSearch({
        orderId: searchOrderValue,
        pageSize: this.config.asm?.customerSearch?.maxResults
      });
    }
  }
  isNoResultMessageInfoVisible(results, searchFlag, searchElement) {
    const searchTermValid = searchElement.value.length >= 3;
    const hasEntries = !!results.entries && results.entries.length > 0;
    return !this.isLoading && searchTermValid && searchFlag && !hasEntries;
  }
  isSearchResultsVisible(results, searchFlag) {
    return !!results.entries && searchFlag && results.entries.length > 0;
  }
  selectCustomerFromList(event, customer) {
    this.selectedCustomer = customer;
    if (this.isShowSearchingCustomerByOrderInASM) {
      this.customerSelectionForm.controls.searchTerm.setValue(this.selectedCustomer.name, {
        emitEvent: false
      });
    } else {
      this.customerSelectionForm.controls.searchTerm.setValue(this.selectedCustomer.name);
    }
    this.asmService.customerSearchReset();
    if (!this.isShowSearchingCustomerByOrderInASM) {
      this.searchTerm.nativeElement.focus();
    }
    event.preventDefault();
    event.stopPropagation();
  }
  onSubmit() {
    if (this.isShowSearchingCustomerByOrderInASM) {
      if (!!this.selectedCustomer) {
        this.submitEvent.emit({
          customerId: this.selectedCustomer.customerId,
          parameters: {
            orderId: this.customerSelectionForm.controls.searchOrder.value
          }
        });
      } else {
        this.customerSelectionForm.markAllAsTouched();
      }
    } else {
      if (this.customerSelectionForm.valid && !!this.selectedCustomer) {
        this.submitEvent.emit({
          customerId: this.selectedCustomer.customerId
        });
      } else {
        this.customerSelectionForm.markAllAsTouched();
      }
    }
  }
  onDocumentClick(event) {
    if (Boolean(this.resultList)) {
      if (this.resultList.nativeElement.contains(event.target) || this.searchTerm.nativeElement.contains(event.target)) {
        return;
      } else {
        this.asmService.customerSearchReset();
      }
    }
  }
  closeResults(event) {
    this.asmService.customerSearchReset();
    this.searchTerm.nativeElement.focus();
    event.preventDefault();
    event.stopPropagation();
  }
  closeOrderSearchResults(event) {
    this.asmService.customerSearchReset();
    this.searchOrder.nativeElement.focus();
    event.preventDefault();
    event.stopPropagation();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.asmService.customerSearchReset();
  }
  /**
   * set focus to the first searched item
   * @param event keyboard event
   */
  focusFirstItem(event) {
    event.preventDefault();
    this.activeFocusedButtonIndex = 0;
    this.updateItemIndex(this.activeFocusedButtonIndex);
  }
  /**
   * set mouse cursor to the end of search text
   * @param event keyboard event
   */
  setSelectionEnd(event) {
    event.preventDefault();
    if (this.searchTerm.nativeElement.value?.length) {
      const selectionStart = this.searchTerm.nativeElement.value.length;
      this.searchTerm.nativeElement.selectionStart = selectionStart;
      this.searchTerm.nativeElement.selectionEnd = selectionStart;
    }
  }
  /**
   * set mouse cursor to the end of search order text
   * @param event keyboard event
   */
  setOrderSearchSelectionEnd(event) {
    event.preventDefault();
    if (this.searchOrder.nativeElement.value?.length) {
      const selectionStart = this.searchOrder.nativeElement.value.length;
      this.searchOrder.nativeElement.selectionStart = selectionStart;
      this.searchOrder.nativeElement.selectionEnd = selectionStart;
    }
  }
  /**
   * set focus on previous searh result item.  If no previous item then go to end of item.
   * @param event keyboard event
   */
  focusPreviousChild(event) {
    event.preventDefault();
    this.activeFocusedButtonIndex--;
    if (this.activeFocusedButtonIndex < 0) {
      this.activeFocusedButtonIndex = this.searchResultItems.length - 1;
    }
    this.updateItemIndex(this.activeFocusedButtonIndex);
  }
  /**
   * set focus on next searh result item.  if no next item then go to the first item
   * @param event keyboard event
   */
  focusNextChild(event) {
    event.preventDefault();
    this.activeFocusedButtonIndex++;
    if (this.activeFocusedButtonIndex > this.searchResultItems.length - 1) {
      this.activeFocusedButtonIndex = 0;
    }
    this.updateItemIndex(this.activeFocusedButtonIndex);
  }
  /**
   * set focus to input search text
   * @param event keyboard event
   */
  focusInputText(event) {
    event.preventDefault();
    this.activeFocusedButtonIndex = -1;
    this.searchTerm.nativeElement.focus();
    if (this.searchTerm.nativeElement.value?.length) {
      let selectionPos = this.searchTerm.nativeElement.selectionEnd;
      const searchTermLength = this.searchTerm.nativeElement.value.length;
      if (this.isBackNavigation(event)) {
        selectionPos = selectionPos <= 0 ? 0 : selectionPos - 1;
      } else if (this.isForwardsNavigation(event)) {
        selectionPos = selectionPos >= searchTermLength ? searchTermLength : selectionPos + 1;
      } else if (event.code === 'Home') {
        selectionPos = 0;
      } else if (event.code === 'End') {
        selectionPos = searchTermLength;
      }
      this.searchTerm.nativeElement.selectionStart = selectionPos;
      this.searchTerm.nativeElement.selectionEnd = selectionPos;
    }
  }
  /**
   * set focus to order search input search text
   * @param event keyboard event
   */
  focusOrderSearchInputText(event) {
    event.preventDefault();
    this.activeFocusedButtonIndex = -1;
    this.searchOrder.nativeElement.focus();
    if (this.searchOrder.nativeElement.value?.length) {
      let selectionPos = this.searchOrder.nativeElement.selectionEnd;
      const searchTermLength = this.searchOrder.nativeElement.value.length;
      if (this.isBackNavigation(event)) {
        selectionPos = selectionPos <= 0 ? 0 : selectionPos - 1;
      } else if (this.isForwardsNavigation(event)) {
        selectionPos = selectionPos >= searchTermLength ? searchTermLength : selectionPos + 1;
      } else if (event.code === 'Home') {
        selectionPos = 0;
      } else if (event.code === 'End') {
        selectionPos = searchTermLength;
      }
      this.searchOrder.nativeElement.selectionStart = selectionPos;
      this.searchOrder.nativeElement.selectionEnd = selectionPos;
    }
  }
  /**
   * set focus to selected item
   * @param {number} selectedIndex - current selected item index
   */
  updateItemIndex(selectedIndex) {
    this.searchResultItems.toArray()?.[selectedIndex]?.nativeElement.focus();
  }
  createCustomer() {
    this.asmService.customerSearchReset();
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ASM_CREATE_CUSTOMER_FORM, this.createCustomerLink);
    if (this.isShowSearchingCustomerByOrderInASM) {
      setTimeout(() => {
        this.searchTerm.nativeElement.blur();
      });
    }
  }
  /**
   * Verifies whether the user navigates into a subgroup of the main group menu.
   *
   * @param {KeyboardEvent} event - Keyboard event
   * @returns {boolean} -'true' if the user navigates into the subgroup, otherwise 'false'.
   * @protected
   */
  isForwardsNavigation(event) {
    return event.code === 'ArrowRight' && this.isLTRDirection() || event.code === 'ArrowLeft' && this.isRTLDirection();
  }
  /**
   * Verifies whether the user navigates from a subgroup back to the main group menu.
   *
   * @param {KeyboardEvent} event - Keyboard event
   * @returns {boolean} -'true' if the user navigates back into the main group menu, otherwise 'false'.
   * @protected
   */
  isBackNavigation(event) {
    return event.code === 'ArrowLeft' && this.isLTRDirection() || event.code === 'ArrowRight' && this.isRTLDirection();
  }
  isLTRDirection() {
    return this.directionService.getDirection() === DirectionMode.LTR;
  }
  isRTLDirection() {
    return this.directionService.getDirection() === DirectionMode.RTL;
  }
  static {
    this.ɵfac = function CustomerSelectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CustomerSelectionComponent)(i0.ɵɵdirectiveInject(i1$2.UntypedFormBuilder), i0.ɵɵdirectiveInject(i2$3.AsmService), i0.ɵɵdirectiveInject(i2$1.AsmConfig), i0.ɵɵdirectiveInject(i1.DirectionService), i0.ɵɵdirectiveInject(i1.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CustomerSelectionComponent,
      selectors: [["cx-customer-selection"]],
      viewQuery: function CustomerSelectionComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
          i0.ɵɵviewQuery(_c6, 5);
          i0.ɵɵviewQuery(_c7, 5);
          i0.ɵɵviewQuery(_c8, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resultList = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchTerm = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchOrder = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.createCustomerLink = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchResultItems = _t);
        }
      },
      hostBindings: function CustomerSelectionComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function CustomerSelectionComponent_click_HostBindingHandler($event) {
            return ctx.onDocumentClick($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      outputs: {
        submitEvent: "submitEvent"
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [["searchTerm", ""], ["searchOrder", ""], ["resultList", ""], ["createCustomerLink", ""], ["searchResultItem", ""], [3, "formGroup", "ngSubmit", 4, "cxFeature"], [4, "cxFeature"], [3, "ngSubmit", "formGroup"], [1, "searchLabel"], ["required", "true", "type", "text", "formControlName", "searchTerm", 3, "keydown.arrowdown", "keydown.end", "placeholder"], [4, "ngIf"], ["class", "asm-results", 4, "ngIf"], ["required", "true", "type", "text", "formControlName", "searchOrder", 3, "keydown.arrowdown", "keydown.end", "placeholder"], ["type", "submit", 3, "disabled"], ["class", "cx-message cx-message-info selection-message-info", 4, "ngIf"], [1, "cx-message", "cx-message-info", "selection-message-info"], [1, "cx-message-content"], [1, "cx-message-header"], [1, "cx-message-icon"], ["ng-reflect-type", "INFO", 1, "cx-icon", "fas", "fa-info-circle"], [1, "cx-message-text"], [1, "linkStyleLabel", 3, "click"], [1, "asm-results"], [3, "tabindex", "active", "keydown.arrowup", "keydown.arrowdown", "keydown.arrowright", "keydown.arrowleft", "keydown.enter", "keydown.escape", "keydown.home", "keydown.end", "click", 4, "ngFor", "ngForOf"], [3, "keydown.arrowup", "keydown.arrowdown", "keydown.arrowright", "keydown.arrowleft", "keydown.enter", "keydown.escape", "keydown.home", "keydown.end", "click", "tabindex"], [1, "result-name"], [1, "result-id"], ["aria-hidden", "false"], ["id", "searchTermError", 3, "translationParams", "control"], ["type", "submit"], [3, "active", "click", "keydown.escape", "keydown.arrowright", "keydown.arrowleft", "keydown.home", "keydown.end", 4, "ngIf"], [3, "click", "keydown.escape", "keydown.arrowright", "keydown.arrowleft", "keydown.home", "keydown.end"], [1, "linkStyleLabel"]],
      template: function CustomerSelectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CustomerSelectionComponent_form_0_Template, 26, 33, "form", 5)(1, CustomerSelectionComponent_div_1_Template, 16, 26, "div", 6);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFeature", "showSearchingCustomerByOrderInASM");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!showSearchingCustomerByOrderInASM");
        }
      },
      dependencies: [i5.NgForOf, i5.NgIf, i1$2.ɵNgNoValidate, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.NgControlStatusGroup, i1$2.RequiredValidator, i1$2.FormGroupDirective, i1$2.FormControlName, i1.FormErrorsComponent, i1.IconComponent, i1$1.FeatureDirective, DotSpinnerComponent, i5.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomerSelectionComponent, [{
    type: Component,
    args: [{
      selector: 'cx-customer-selection',
      host: {
        '(document:click)': 'onDocumentClick($event)'
      },
      standalone: false,
      template: "<form\n  *cxFeature=\"'showSearchingCustomerByOrderInASM'\"\n  (ngSubmit)=\"onSubmit()\"\n  [formGroup]=\"customerSelectionForm\"\n>\n  <span class=\"searchLabel\">{{\n    'asm.customerSearch.customer' | cxTranslate\n  }}</span>\n  <label>\n    <input\n      required=\"true\"\n      #searchTerm\n      type=\"text\"\n      formControlName=\"searchTerm\"\n      [attr.aria-label]=\"\n        'asm.customerSearch.searchCustomer.label' | cxTranslate\n      \"\n      placeholder=\"{{\n        'asm.customerSearch.searchCustomer.label' | cxTranslate\n      }}\"\n      (keydown.arrowdown)=\"focusFirstItem($event)\"\n      (keydown.end)=\"setSelectionEnd($event)\"\n    />\n\n    <div *ngIf=\"searchResults | async as results\" #resultList>\n      <div\n        *ngIf=\"\n          isNoResultMessageInfoVisible(results, searchByCustomer, searchTerm)\n        \"\n        class=\"cx-message cx-message-info selection-message-info\"\n      >\n        <div class=\"cx-message-content\">\n          <div class=\"cx-message-header\">\n            <span class=\"cx-message-icon\">\n              <cx-icon\n                class=\"cx-icon fas fa-info-circle\"\n                ng-reflect-type=\"INFO\"\n              ></cx-icon>\n            </span>\n            <span class=\"cx-message-text\"\n              >{{ 'asm.customerSearch.noCustomerMatchResult' | cxTranslate }}\n            </span>\n            <span\n              #createCustomerLink\n              class=\"linkStyleLabel\"\n              (click)=\"createCustomer()\"\n            >\n              {{ 'asm.customerSearch.createCustomer' | cxTranslate }}\n            </span>\n          </div>\n        </div>\n      </div>\n      <div\n        *ngIf=\"isSearchResultsVisible(results, searchByCustomer)\"\n        class=\"asm-results\"\n      >\n        <button\n          #searchResultItem\n          *ngFor=\"let result of results.entries; let i = index\"\n          [tabindex]=\"activeFocusedButtonIndex === i ? 0 : -1\"\n          [attr.aria-selected]=\"activeFocusedButtonIndex === i\"\n          [class.active]=\"activeFocusedButtonIndex === i\"\n          (keydown.arrowup)=\"focusPreviousChild($event)\"\n          (keydown.arrowdown)=\"focusNextChild($event)\"\n          (keydown.arrowright)=\"focusInputText($event)\"\n          (keydown.arrowleft)=\"focusInputText($event)\"\n          (keydown.enter)=\"selectCustomerFromList($event, result)\"\n          (keydown.escape)=\"closeResults($event)\"\n          (keydown.home)=\"focusInputText($event)\"\n          (keydown.end)=\"focusInputText($event)\"\n          (click)=\"selectCustomerFromList($event, result)\"\n        >\n          <div class=\"result-name\">{{ result.name }}</div>\n          <div class=\"result-id\">\n            <span>{{ result.uid }}</span>\n          </div>\n        </button>\n      </div>\n    </div>\n\n    <div class=\"asm-results\" *ngIf=\"isLoading && searchByCustomer\">\n      <cx-dot-spinner\n        aria-hidden=\"false\"\n        [attr.aria-label]=\"'common.loading' | cxTranslate\"\n      ></cx-dot-spinner>\n    </div>\n  </label>\n  <span class=\"searchLabel\">{{\n    'asm.customerSearch.orderID' | cxTranslate\n  }}</span>\n\n  <label>\n    <input\n      required=\"true\"\n      #searchOrder\n      type=\"text\"\n      formControlName=\"searchOrder\"\n      [attr.aria-label]=\"'asm.customerSearch.searchOrder.label' | cxTranslate\"\n      placeholder=\"{{ 'asm.customerSearch.searchOrder.label' | cxTranslate }}\"\n      (keydown.arrowdown)=\"focusFirstItem($event)\"\n      (keydown.end)=\"setOrderSearchSelectionEnd($event)\"\n    />\n    <div *ngIf=\"searchResults | async as results\" #resultList>\n      <div\n        *ngIf=\"\n          isNoResultMessageInfoVisible(results, searchByOrder, searchOrder)\n        \"\n        class=\"cx-message cx-message-info selection-message-info\"\n      >\n        <div class=\"cx-message-content\">\n          <div class=\"cx-message-header\">\n            <span class=\"cx-message-icon\">\n              <cx-icon\n                class=\"cx-icon fas fa-info-circle\"\n                ng-reflect-type=\"INFO\"\n              ></cx-icon>\n            </span>\n            <span class=\"cx-message-text\">\n              {{ 'asm.customerSearch.noOrderMatchResult' | cxTranslate }}\n            </span>\n          </div>\n        </div>\n      </div>\n      <div\n        *ngIf=\"isSearchResultsVisible(results, searchByOrder)\"\n        class=\"asm-results\"\n      >\n        <button\n          #searchResultItem\n          *ngFor=\"let result of results.entries; let i = index\"\n          [tabindex]=\"activeFocusedButtonIndex === i ? 0 : -1\"\n          [attr.aria-selected]=\"activeFocusedButtonIndex === i\"\n          [class.active]=\"activeFocusedButtonIndex === i\"\n          (keydown.arrowup)=\"focusPreviousChild($event)\"\n          (keydown.arrowdown)=\"focusNextChild($event)\"\n          (keydown.arrowright)=\"focusOrderSearchInputText($event)\"\n          (keydown.arrowleft)=\"focusOrderSearchInputText($event)\"\n          (keydown.enter)=\"selectCustomerFromList($event, result)\"\n          (keydown.escape)=\"closeOrderSearchResults($event)\"\n          (keydown.home)=\"focusOrderSearchInputText($event)\"\n          (keydown.end)=\"focusOrderSearchInputText($event)\"\n          (click)=\"selectCustomerFromList($event, result)\"\n        >\n          <div class=\"result-name\">{{ searchOrder.value }}</div>\n          <div class=\"result-id\">\n            <span>{{ result.name }}</span>\n          </div>\n        </button>\n      </div>\n    </div>\n\n    <div class=\"asm-results\" *ngIf=\"isLoading && searchByOrder\">\n      <cx-dot-spinner\n        aria-hidden=\"false\"\n        [attr.aria-label]=\"'common.loading' | cxTranslate\"\n      ></cx-dot-spinner>\n    </div>\n  </label>\n\n  <button\n    type=\"submit\"\n    [class.active]=\"selectedCustomer\"\n    [disabled]=\"!selectedCustomer\"\n  >\n    {{ 'asm.customerSearch.submit' | cxTranslate }}\n  </button>\n</form>\n\n<div *cxFeature=\"'!showSearchingCustomerByOrderInASM'\">\n  <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"customerSelectionForm\">\n    <label>\n      <input\n        required=\"true\"\n        #searchTerm\n        type=\"text\"\n        formControlName=\"searchTerm\"\n        [attr.aria-label]=\"'asm.customerSearch.searchTerm.label' | cxTranslate\"\n        [attr.aria-invalid]=\"\n          customerSelectionForm.get('searchTerm')?.touched &&\n          customerSelectionForm.get('searchTerm')?.invalid\n        \"\n        [attr.aria-errormessage]=\"'searchTermError'\"\n        placeholder=\"{{ 'asm.customerSearch.searchTerm.label' | cxTranslate }}\"\n        (keydown.arrowdown)=\"focusFirstItem($event)\"\n        (keydown.end)=\"setSelectionEnd($event)\"\n      />\n\n      <cx-form-errors\n        id=\"searchTermError\"\n        [translationParams]=\"{\n          label: 'asm.customerSearch.searchTerm.label' | cxTranslate,\n        }\"\n        [control]=\"customerSelectionForm.get('searchTerm')\"\n      ></cx-form-errors>\n    </label>\n    <button type=\"submit\" [class.active]=\"selectedCustomer\">\n      {{ 'asm.customerSearch.submit' | cxTranslate }}\n    </button>\n  </form>\n\n  <div *ngIf=\"searchResults | async as results\" class=\"asm-results\" #resultList>\n    <button\n      #searchResultItem\n      *ngFor=\"let result of results.entries; let i = index\"\n      [tabindex]=\"activeFocusedButtonIndex === i ? 0 : -1\"\n      [attr.aria-selected]=\"activeFocusedButtonIndex === i\"\n      [class.active]=\"activeFocusedButtonIndex === i\"\n      (keydown.arrowup)=\"focusPreviousChild($event)\"\n      (keydown.arrowdown)=\"focusNextChild($event)\"\n      (keydown.arrowright)=\"focusInputText($event)\"\n      (keydown.arrowleft)=\"focusInputText($event)\"\n      (keydown.enter)=\"selectCustomerFromList($event, result)\"\n      (keydown.escape)=\"closeResults($event)\"\n      (keydown.home)=\"focusInputText($event)\"\n      (keydown.end)=\"focusInputText($event)\"\n      (click)=\"selectCustomerFromList($event, result)\"\n    >\n      <span class=\"result-name\">{{ result.name }}</span>\n      <span class=\"result-id\">{{ result.uid }}</span>\n    </button>\n\n    <button\n      #searchResultItem\n      (click)=\"createCustomer()\"\n      (keydown.escape)=\"closeResults($event)\"\n      (keydown.arrowright)=\"focusInputText($event)\"\n      (keydown.arrowleft)=\"focusInputText($event)\"\n      (keydown.home)=\"focusInputText($event)\"\n      (keydown.end)=\"focusInputText($event)\"\n      [class.active]=\"activeFocusedButtonIndex === 0\"\n      [attr.aria-selected]=\"activeFocusedButtonIndex === 0\"\n      *ngIf=\"\n        !(searchResultsLoading$ | async) &&\n        searchTerm.value.length >= 3 &&\n        !!results.entries &&\n        results.entries.length <= 0\n      \"\n    >\n      <span>{{ 'asm.customerSearch.noMatchResult' | cxTranslate }}</span>\n      <span #createCustomerLink class=\"linkStyleLabel\">{{\n        'asm.customerSearch.createCustomer' | cxTranslate\n      }}</span>\n    </button>\n  </div>\n\n  <div class=\"asm-results\" *ngIf=\"searchResultsLoading$ | async\">\n    <cx-dot-spinner\n      aria-hidden=\"false\"\n      [attr.aria-label]=\"'common.loading' | cxTranslate\"\n    ></cx-dot-spinner>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1$2.UntypedFormBuilder
  }, {
    type: i2$3.AsmService
  }, {
    type: i2$1.AsmConfig
  }, {
    type: i1.DirectionService
  }, {
    type: i1.LaunchDialogService
  }], {
    submitEvent: [{
      type: Output
    }],
    resultList: [{
      type: ViewChild,
      args: ['resultList']
    }],
    searchTerm: [{
      type: ViewChild,
      args: ['searchTerm']
    }],
    searchOrder: [{
      type: ViewChild,
      args: ['searchOrder']
    }],
    createCustomerLink: [{
      type: ViewChild,
      args: ['createCustomerLink']
    }],
    searchResultItems: [{
      type: ViewChildren,
      args: ['searchResultItem']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FormatTimerPipe {
  transform(totalSeconds) {
    if (totalSeconds < 0) {
      totalSeconds = 0;
    }
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    let zeroPaddedMinutes;
    if (minutes < 10) {
      zeroPaddedMinutes = ('00' + minutes).slice(-2);
    } else {
      zeroPaddedMinutes = minutes + '';
    }
    const zeroPaddedSeconds = ('00' + seconds).slice(-2);
    return `${zeroPaddedMinutes}:${zeroPaddedSeconds}`;
  }
  static {
    this.ɵfac = function FormatTimerPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormatTimerPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "formatTimer",
      type: FormatTimerPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormatTimerPipe, [{
    type: Pipe,
    args: [{
      name: 'formatTimer',
      standalone: false
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AsmSessionTimerComponent {
  constructor(config, asmComponentService, routingService, changeDetectorRef, userIdService) {
    this.config = config;
    this.asmComponentService = asmComponentService;
    this.routingService = routingService;
    this.changeDetectorRef = changeDetectorRef;
    this.userIdService = userIdService;
    this.subscriptions = new Subscription();
    this.maxStartDelayInSeconds = 60000;
  }
  ngOnInit() {
    this.initTimer();
    this.interval = setInterval(() => {
      const currentSeconds = new Date().getTime() / 1000;
      this.timeLeft = Math.floor(this.expiredTime - currentSeconds);
      if (this.timeLeft <= 0) {
        clearInterval(this.interval);
        this.asmComponentService.logoutCustomerSupportAgentAndCustomer();
      }
      this.changeDetectorRef.markForCheck();
    }, 1000);
    this.resetOnNavigate();
    this.resetOnCustomerSessionChange();
  }
  resetOnNavigate() {
    this.subscriptions.add(this.routingService.isNavigating().subscribe(isNavigating => {
      if (isNavigating) {
        this.resetTimer();
      }
    }));
  }
  resetOnCustomerSessionChange() {
    this.subscriptions.add(this.userIdService.getUserId().pipe(distinctUntilChanged()).subscribe(() => this.resetTimer()));
  }
  initTimer() {
    const timeoutPropertyInSeconds = this.getTimerStartDelayInSeconds();
    const currentSeconds = new Date().getTime() / 1000;
    this.timeLeft = timeoutPropertyInSeconds;
    this.expiredTime = currentSeconds + this.timeLeft;
  }
  resetTimer() {
    if (this.timeLeft > 0) {
      this.initTimer();
    }
  }
  getTimerStartDelayInSeconds() {
    if (this.config.asm?.agentSessionTimer?.startingDelayInSeconds === undefined) {
      return 600;
    }
    if (this.config.asm.agentSessionTimer.startingDelayInSeconds > this.maxStartDelayInSeconds) {
      return this.maxStartDelayInSeconds;
    } else {
      return this.config.asm.agentSessionTimer.startingDelayInSeconds;
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  static {
    this.ɵfac = function AsmSessionTimerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmSessionTimerComponent)(i0.ɵɵdirectiveInject(i2$1.AsmConfig), i0.ɵɵdirectiveInject(AsmComponentService), i0.ɵɵdirectiveInject(i1$1.RoutingService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.UserIdService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmSessionTimerComponent,
      selectors: [["cx-asm-session-timer"]],
      standalone: false,
      decls: 9,
      vars: 12,
      consts: [[1, "label"], [1, "time"], [1, "reset", 3, "click", "title"]],
      template: function AsmSessionTimerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵtext(1);
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "span", 1);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "formatTimer");
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "button", 2);
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵlistener("click", function AsmSessionTimerComponent_Template_button_click_7_listener() {
            return ctx.resetTimer();
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 4, "asm.agentSessionTimer.label"), ":");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(5, 6, ctx.timeLeft), " ", i0.ɵɵpipeBind1(6, 8, "asm.agentSessionTimer.minutes"), "");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 10, "asm.agentSessionTimer.reset"));
        }
      },
      dependencies: [i1$1.TranslatePipe, FormatTimerPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmSessionTimerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-session-timer',
      standalone: false,
      template: "<span class=\"label\">{{ 'asm.agentSessionTimer.label' | cxTranslate }}:</span>\n<span class=\"time\"\n  >{{ timeLeft | formatTimer }}\n  {{ 'asm.agentSessionTimer.minutes' | cxTranslate }}</span\n>\n<button\n  class=\"reset\"\n  title=\"{{ 'asm.agentSessionTimer.reset' | cxTranslate }}\"\n  (click)=\"resetTimer()\"\n></button>\n"
    }]
  }], () => [{
    type: i2$1.AsmConfig
  }, {
    type: AsmComponentService
  }, {
    type: i1$1.RoutingService
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i1$1.UserIdService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CustomerEmulationComponent {
  constructor(asmComponentService, userAccountFacade, launchDialogService, featureModules) {
    this.asmComponentService = asmComponentService;
    this.userAccountFacade = userAccountFacade;
    this.launchDialogService = launchDialogService;
    this.featureModules = featureModules;
    this.isAsmCustomer360Configured = false;
    this.isAsmCustomer360Loaded$ = new BehaviorSubject(false);
    this.subscription = new Subscription();
    this.featureConfig = inject(FeatureConfigService);
    this.isShowStyleChangesInASM = this.featureConfig.isEnabled('showStyleChangesInASM');
  }
  ngOnInit() {
    this.isAsmCustomer360Configured = this.featureModules?.isConfigured('asmCustomer360');
    if (this.isAsmCustomer360Configured) {
      // trigger lazy loading of the Customer 360 feature:
      this.featureModules?.resolveFeature('asmCustomer360').subscribe(() => {
        this.isAsmCustomer360Loaded$.next(true);
      });
    }
    this.subscription.add(this.userAccountFacade.get().subscribe(user => {
      if (user) {
        this.customer = user;
      }
    }));
    this.isCustomerEmulationSessionInProgress$ = this.asmComponentService.isCustomerEmulationSessionInProgress();
  }
  logoutCustomer() {
    this.asmComponentService.logoutCustomer();
  }
  openAsmCustomer360() {
    this.subscription.add(this.isAsmCustomer360Loaded$.pipe(filter(isReady => Boolean(isReady))).subscribe(() => {
      const data = {
        customer: this.customer
      };
      this.launchDialogService?.openDialogAndSubscribe(LAUNCH_CALLER.ASM_CUSTOMER_360, this.asmCustomer360LauncherElement, data);
      this.subscription.add(this.launchDialogService?.dialogClose.pipe(filter(result => Boolean(result))).subscribe(event => {
        this.asmComponentService.handleAsmDialogAction(event);
      }));
    }));
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function CustomerEmulationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CustomerEmulationComponent)(i0.ɵɵdirectiveInject(AsmComponentService), i0.ɵɵdirectiveInject(i2$4.UserAccountFacade), i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i1$1.FeatureModulesService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CustomerEmulationComponent,
      selectors: [["cx-customer-emulation"]],
      viewQuery: function CustomerEmulationComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c9, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.asmCustomer360LauncherElement = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["asmCustomer360Launcher", ""], [4, "ngIf"], [1, "cx-asm-customerInfo"], [1, "cx-asm-name"], [1, "cx-asm-uid"], ["class", "cx-360-button", 3, "click", 4, "ngIf"], ["formcontrolname", "logoutCustomer", 3, "click"], [1, "cx-360-button", 3, "click"]],
      template: function CustomerEmulationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CustomerEmulationComponent_ng_container_0_Template, 12, 7, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.isCustomerEmulationSessionInProgress$));
        }
      },
      dependencies: [i5.NgIf, AsmBindCartComponent, i5.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomerEmulationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-customer-emulation',
      standalone: false,
      template: "<ng-container *ngIf=\"isCustomerEmulationSessionInProgress$ | async\">\n  <div class=\"cx-asm-customerInfo\">\n    <label class=\"cx-asm-name\">{{ customer?.name }}</label>\n    <label class=\"cx-asm-uid\">{{ customer?.uid }}</label>\n  </div>\n  <cx-asm-bind-cart></cx-asm-bind-cart>\n  <button\n    *ngIf=\"isAsmCustomer360Configured && customer && isShowStyleChangesInASM\"\n    #asmCustomer360Launcher\n    class=\"cx-360-button\"\n    (click)=\"openAsmCustomer360()\"\n  >\n    {{ 'asm.asmCustomer360ViewButton' | cxTranslate }}\n  </button>\n  <button\n    *ngIf=\"isAsmCustomer360Configured && customer && !isShowStyleChangesInASM\"\n    #asmCustomer360Launcher\n    class=\"cx-360-button\"\n    (click)=\"openAsmCustomer360()\"\n  >\n    {{ 'asm.asmCustomer360Button' | cxTranslate }}\n  </button>\n  <button formcontrolname=\"logoutCustomer\" (click)=\"logoutCustomer()\">\n    {{ 'asm.endSession' | cxTranslate }}\n  </button>\n</ng-container>\n"
    }]
  }], () => [{
    type: AsmComponentService
  }, {
    type: i2$4.UserAccountFacade
  }, {
    type: i1.LaunchDialogService
  }, {
    type: i1$1.FeatureModulesService
  }], {
    asmCustomer360LauncherElement: [{
      type: ViewChild,
      args: ['asmCustomer360Launcher']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AsmToggleUiComponent {
  constructor(asmService) {
    this.asmService = asmService;
    this.subscription = new Subscription();
  }
  ngOnInit() {
    this.subscription.add(this.asmService.getAsmUiState().subscribe(uiState => {
      this.isCollapsed = uiState.collapsed === undefined ? false : uiState.collapsed;
    }));
  }
  toggleUi() {
    this.asmService.updateAsmUiState({
      collapsed: !this.isCollapsed
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function AsmToggleUiComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmToggleUiComponent)(i0.ɵɵdirectiveInject(i2$3.AsmService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmToggleUiComponent,
      selectors: [["cx-asm-toggle-ui"]],
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["tabindex", "0", "role", "button", 1, "toggleUi", 3, "click"], [3, "ngClass"], ["class", "label", 4, "ngIf"], [1, "label"]],
      template: function AsmToggleUiComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵlistener("click", function AsmToggleUiComponent_Template_a_click_0_listener() {
            return ctx.toggleUi();
          });
          i0.ɵɵelement(1, "span", 1);
          i0.ɵɵtemplate(2, AsmToggleUiComponent_span_2_Template, 3, 3, "span", 2)(3, AsmToggleUiComponent_span_3_Template, 3, 3, "span", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", !ctx.isCollapsed ? "collapseIcon" : "expandIcon");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.isCollapsed);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isCollapsed);
        }
      },
      dependencies: [i5.NgClass, i5.NgIf, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmToggleUiComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-toggle-ui',
      standalone: false,
      template: "<a class=\"toggleUi\" (click)=\"toggleUi()\" tabindex=\"0\" role=\"button\">\n  <span [ngClass]=\"!isCollapsed ? 'collapseIcon' : 'expandIcon'\"></span>\n  <span *ngIf=\"!isCollapsed\" class=\"label\">\n    {{ 'asm.toggleUi.collapse' | cxTranslate }}\n  </span>\n  <span *ngIf=\"isCollapsed\" class=\"label\">\n    {{ 'asm.toggleUi.expand' | cxTranslate }}\n  </span>\n</a>\n"
    }]
  }], () => [{
    type: i2$3.AsmService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CART_TYPE_KEY = {
  active: 'asm.activeCartAlertInfo',
  inactive: 'asm.saveInactiveCartAlertInfo'
};
class AsmMainUiComponent {
  constructor(authService, csAgentAuthService, asmComponentService, globalMessageService, routingService, asmService, userAccountFacade, launchDialogService) {
    this.authService = authService;
    this.csAgentAuthService = csAgentAuthService;
    this.asmComponentService = asmComponentService;
    this.globalMessageService = globalMessageService;
    this.routingService = routingService;
    this.asmService = asmService;
    this.userAccountFacade = userAccountFacade;
    this.launchDialogService = launchDialogService;
    this.iconTypes = ICON_TYPE;
    this.forbiddenResponseStatus = HttpResponseStatus.FORBIDDEN;
    this.showDeeplinkCartInfoAlert$ = this.asmComponentService.shouldShowDeeplinkCartInfoAlert();
    this.deeplinkCartAlertKey = '';
    this.showCreateCustomerSuccessfullyAlert = false;
    this.globalMessageType = GlobalMessageType;
    this.disabled = false;
    this.startingCustomerSession = false;
    this.showCustomerEmulationInfoAlert = true;
    this.subscription = new Subscription();
  }
  ngOnInit() {
    this.customerSupportAgentLoggedIn$ = this.csAgentAuthService.isCustomerSupportAgentLoggedIn().pipe(distinctUntilChanged(), tap(loggedIn => {
      if (!loggedIn) {
        this.closeModal();
      }
    }));
    this.csAgentTokenLoading$ = this.csAgentAuthService.getCustomerSupportAgentTokenLoading();
    this.customer$ = this.authService.isUserLoggedIn().pipe(switchMap(isLoggedIn => {
      if (isLoggedIn) {
        this.handleCustomerSessionStartRedirection();
        return this.userAccountFacade.get();
      } else {
        return of(undefined);
      }
    }));
    this.isCollapsed$ = this.asmService.getAsmUiState().pipe(map(uiState => uiState.collapsed === undefined ? false : uiState.collapsed));
    this.asmService.getAsmUiState().subscribe(state => {
      if (state.status === this.forbiddenResponseStatus) {
        this.logout();
        this.hideUi();
        this.asmService.updateAsmUiState({
          status: undefined
        });
      }
    });
    this.subscription.add(this.launchDialogService.dialogClose.pipe(filter(result => Boolean(result))).subscribe(result => {
      if (typeof result !== 'string') {
        if ('selectedUser' in result) {
          this.startCustomerEmulationSession(result.selectedUser);
          if (result.actionType === CustomerListColumnActionType.ORDER_HISTORY) {
            this.routingService.go({
              cxRoute: 'orders'
            });
          }
        } else if ('customerId' in result) {
          this.startCustomerEmulationSession({
            customerId: result.customerId
          });
          this.showCreateCustomerSuccessfullyAlert = true;
          this.routingService.go('/');
        }
        if ('actionType' in result && result.actionType === CustomerListColumnActionType.ACTIVE_CART) {
          this.routingService.go({
            cxRoute: 'cart'
          });
        } else if ('actionType' in result && result.actionType === CustomerListColumnActionType.CUSTOMER_360) {
          this.customer$.pipe(filter(curCustomer => !!curCustomer), take(1)).subscribe(customer => {
            setTimeout(() => {
              this.showC360Dialog(customer);
            }, 500);
          });
        }
      }
      if (result === CLOSE_DIALOG_REASON.FORBIDDEN) {
        this.logout();
        this.hideUi();
      }
    }));
    this.subscribeForDeeplink();
  }
  showC360Dialog(customer) {
    const data = {
      customer: customer
    };
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ASM_CUSTOMER_360, this.element, data);
    this.subscription.add(this.launchDialogService.dialogClose.pipe(filter(closeContent => Boolean(closeContent))).subscribe(event => {
      this.asmComponentService.handleAsmDialogAction(event);
    }));
  }
  /**
   * When agent is logged in and deep link has customerID,
   * call logout if has customer emulated(userLoggedin) but not emulated by deep link.
   * call startSessionWithParameters
   */
  subscribeForDeeplink() {
    if (this.asmComponentService.isEmulateInURL()) {
      //Always route to home page to avoid 404
      this.routingService.go('/');
    }
    const parameters = this.asmComponentService.getDeepLinkUrlParams() ?? {
      customerId: this.asmComponentService.getSearchParameter('customerId'),
      orderId: this.asmComponentService.getSearchParameter('orderId'),
      ticketId: this.asmComponentService.getSearchParameter('ticketId'),
      cartId: this.asmComponentService.getSearchParameter('cartId'),
      cartType: this.asmComponentService.getSearchParameter('cartType'),
      emulated: false
    };
    this.deeplinkCartAlertKey = CART_TYPE_KEY[parameters.cartType || ''];
    this.subscription.add(combineLatest([this.customerSupportAgentLoggedIn$, this.authService.isUserLoggedIn(), this.asmComponentService.isEmulatedByDeepLink()]).subscribe(([agentLoggedIn, userLoggedin, isEmulatedByDeepLink]) => {
      if (agentLoggedIn && parameters.customerId) {
        if (!isEmulatedByDeepLink && userLoggedin) {
          this.confirmSwitchCustomer(parameters.customerId);
        } else {
          setTimeout(() => this.startSessionWithParameters({
            ...parameters,
            emulated: isEmulatedByDeepLink
          }));
        }
      }
    }));
  }
  confirmSwitchCustomer(switchCustomerId) {
    this.customer$.pipe(filter(curCustomer => !!curCustomer), take(1)).subscribe(curCustomer => {
      if (curCustomer?.customerId !== switchCustomerId) {
        this.userAccountFacade.getById(switchCustomerId).subscribe({
          next: switchCustomer => {
            this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ASM_SWITCH_CUSTOMER, this.element, {
              curCustomer: curCustomer,
              switchCustomer: switchCustomer
            });
          },
          error: error => {
            this.globalMessageService.add(error.details?.[0].message ?? '', GlobalMessageType.MSG_TYPE_ERROR);
          }
        });
      } else {
        this.asmComponentService.setEmulatedByDeepLink(true);
      }
    });
  }
  /**
   * If url contains customerId and we haven't emulatedFromURL, we'll change the isEmulatedByDeepLink flag and
   * start emulate customer in URL.
   */
  startSessionWithParameters(parameters) {
    if (!parameters.emulated) {
      this.asmComponentService.setEmulatedByDeepLink(true);
      this.startCustomerEmulationSession({
        customerId: parameters.customerId
      }, parameters);
    }
  }
  handleCustomerSessionStartRedirection() {
    this.asmComponentService.isCustomerEmulationSessionInProgress().pipe(take(1)).subscribe(isCustomerEmulated => {
      if (this.startingCustomerSession && isCustomerEmulated) {
        this.startingCustomerSession = false;
        this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
        this.routingService.go('/');
      }
    });
  }
  loginCustomerSupportAgent({
    userId,
    password
  }) {
    this.csAgentAuthService.authorizeCustomerSupportAgent(userId, password);
  }
  logout() {
    this.asmComponentService.logoutCustomerSupportAgentAndCustomer();
  }
  startCustomerEmulationSession({
    customerId
  }, parameters) {
    if (customerId) {
      this.csAgentAuthService.startCustomerEmulationSession(customerId);
      this.startingCustomerSession = true;
      this.showCustomerEmulationInfoAlert = true;
      this.showCreateCustomerSuccessfullyAlert = false;
      if (parameters) {
        this.asmComponentService.handleDeepLinkNavigation({
          customerId,
          ...parameters
        });
      }
    } else {
      this.globalMessageService.add({
        key: 'asm.error.noCustomerId'
      }, GlobalMessageType.MSG_TYPE_ERROR);
    }
  }
  hideUi() {
    this.disabled = true;
    this.asmComponentService.unload();
  }
  showCustomList() {
    this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.ASM_CUSTOMER_LIST, this.element);
  }
  closeModal() {
    this.launchDialogService.closeDialog('logout');
  }
  createCustomer() {
    this.launchDialogService?.openDialogAndSubscribe(LAUNCH_CALLER.ASM_CREATE_CUSTOMER_FORM, this.addNewCustomerLink);
  }
  closeDialogConfirmationAlert() {
    this.showCreateCustomerSuccessfullyAlert = false;
  }
  closeDeeplinkCartInfoAlert() {
    this.asmComponentService.setShowDeeplinkCartInfoAlert(false);
  }
  closeCustomerEmulationInfoAlert() {
    this.showCustomerEmulationInfoAlert = false;
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function AsmMainUiComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmMainUiComponent)(i0.ɵɵdirectiveInject(i1$1.AuthService), i0.ɵɵdirectiveInject(i2$1.CsAgentAuthService), i0.ɵɵdirectiveInject(AsmComponentService), i0.ɵɵdirectiveInject(i1$1.GlobalMessageService), i0.ɵɵdirectiveInject(i1$1.RoutingService), i0.ɵɵdirectiveInject(i2$3.AsmService), i0.ɵɵdirectiveInject(i2$4.UserAccountFacade), i0.ɵɵdirectiveInject(i1.LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmMainUiComponent,
      selectors: [["cx-asm-main-ui"]],
      viewQuery: function AsmMainUiComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c10, 5);
          i0.ɵɵviewQuery(_c11, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addNewCustomerLink = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function AsmMainUiComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("hidden", ctx.disabled);
        }
      },
      standalone: false,
      decls: 27,
      vars: 30,
      consts: [["customerListLink", ""], ["showLoginForm", ""], ["showCustomerSelection", ""], [1, "asm-bar"], [1, "asm-bar-branding"], ["src", "data:image/png;base64,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", "width", "48", "height", "24", 1, "logo", 3, "alt", "title"], [1, "asm-title"], [1, "asm-bar-actions"], [1, "cx-asm-help-portal"], ["href", "https://help.sap.com/docs/SAP_COMMERCE_COMPOSABLE_STOREFRONT/d1ca9a1517f847a5b57b4e08400807c1/2367ff04ccb649ac82a3795ecf72a804.html?locale=en-US", "target", "_blank", "rel", "noopener noreferrer", "role", "button"], [3, "type"], ["class", "cx-asm-customer-list", 4, "ngIf"], [4, "ngIf"], ["class", "close", 3, "title", "click", 4, "ngIf"], ["class", "logout", 3, "title", "click", 4, "ngIf"], [1, "cx-asm-customer-list"], ["tabindex", "0", "role", "button", 1, "cx-asm-customer-list-link", 3, "click"], [1, "close", 3, "click", "title"], [1, "logout", 3, "click", "title"], [4, "ngIf", "ngIfElse"], [3, "text", "type", "closeMessage", 4, "ngIf"], [3, "closeMessage", "text", "type"], [3, "submitEvent", 4, "ngIf"], [3, "submitEvent"], [3, "csAgentTokenLoading", "submitEvent", 4, "ngIf"], [3, "submitEvent", "csAgentTokenLoading"]],
      template: function AsmMainUiComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
          i0.ɵɵelement(2, "img", 5);
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵelementStart(5, "div", 6);
          i0.ɵɵtext(6);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(8, "div", 7)(9, "div", 8)(10, "a", 9);
          i0.ɵɵelement(11, "cx-icon", 10);
          i0.ɵɵelementStart(12, "span");
          i0.ɵɵtext(13);
          i0.ɵɵpipe(14, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(15, AsmMainUiComponent_div_15_Template, 7, 4, "div", 11);
          i0.ɵɵpipe(16, "async");
          i0.ɵɵelement(17, "cx-asm-toggle-ui");
          i0.ɵɵtemplate(18, AsmMainUiComponent_cx_asm_session_timer_18_Template, 1, 0, "cx-asm-session-timer", 12);
          i0.ɵɵpipe(19, "async");
          i0.ɵɵtemplate(20, AsmMainUiComponent_button_20_Template, 2, 3, "button", 13);
          i0.ɵɵpipe(21, "async");
          i0.ɵɵpipe(22, "async");
          i0.ɵɵtemplate(23, AsmMainUiComponent_button_23_Template, 2, 3, "button", 14);
          i0.ɵɵpipe(24, "async");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(25, AsmMainUiComponent_ng_container_25_Template, 5, 4, "ng-container", 12);
          i0.ɵɵpipe(26, "async");
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("alt", i0.ɵɵpipeBind1(3, 10, "asm.mainLogoLabel"));
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 12, "asm.mainLogoLabel"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 14, "asm.mainTitle"), " ");
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("type", ctx.iconTypes.HELP);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 16, "asm.helpPortalUrl"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(16, 18, ctx.customerSupportAgentLoggedIn$));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(19, 20, ctx.customerSupportAgentLoggedIn$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(21, 22, ctx.customerSupportAgentLoggedIn$) && !i0.ɵɵpipeBind1(22, 24, ctx.csAgentTokenLoading$));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(24, 26, ctx.customerSupportAgentLoggedIn$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(26, 28, ctx.isCollapsed$));
        }
      },
      dependencies: [i5.NgIf, i1.IconComponent, i1.MessageComponent, CSAgentLoginFormComponent, CustomerSelectionComponent, AsmSessionTimerComponent, CustomerEmulationComponent, AsmToggleUiComponent, i5.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmMainUiComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-main-ui',
      standalone: false,
      template: "<div class=\"asm-bar\">\n  <div class=\"asm-bar-branding\">\n    <img\n      class=\"logo\"\n      src=\"data:image/png;base64,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\"\n      width=\"48\"\n      height=\"24\"\n      alt=\"{{ 'asm.mainLogoLabel' | cxTranslate }}\"\n      title=\"{{ 'asm.mainLogoLabel' | cxTranslate }}\"\n    />\n\n    <div class=\"asm-title\">\n      {{ 'asm.mainTitle' | cxTranslate }}\n    </div>\n  </div>\n  <div class=\"asm-bar-actions\">\n    <div class=\"cx-asm-help-portal\">\n      <a\n        href=\"https://help.sap.com/docs/SAP_COMMERCE_COMPOSABLE_STOREFRONT/d1ca9a1517f847a5b57b4e08400807c1/2367ff04ccb649ac82a3795ecf72a804.html?locale=en-US\"\n        target=\"_blank\"\n        rel=\"noopener noreferrer\"\n        role=\"button\"\n      >\n        <cx-icon [type]=\"iconTypes.HELP\"></cx-icon>\n        <span>{{ 'asm.helpPortalUrl' | cxTranslate }}</span></a\n      >\n    </div>\n\n    <div\n      class=\"cx-asm-customer-list\"\n      *ngIf=\"customerSupportAgentLoggedIn$ | async\"\n    >\n      <a\n        #customerListLink\n        tabindex=\"0\"\n        role=\"button\"\n        class=\"cx-asm-customer-list-link\"\n        (click)=\"showCustomList()\"\n      >\n        <cx-icon [type]=\"iconTypes.USER_FRIENDS\"></cx-icon>\n        <span>{{ 'asm.customers' | cxTranslate }}</span></a\n      >\n    </div>\n\n    <cx-asm-toggle-ui></cx-asm-toggle-ui>\n\n    <cx-asm-session-timer\n      *ngIf=\"customerSupportAgentLoggedIn$ | async\"\n    ></cx-asm-session-timer>\n\n    <button\n      class=\"close\"\n      title=\"{{ 'asm.hideUi' | cxTranslate }}\"\n      *ngIf=\"\n        !(customerSupportAgentLoggedIn$ | async) &&\n        !(csAgentTokenLoading$ | async)\n      \"\n      (click)=\"hideUi()\"\n    ></button>\n\n    <button\n      class=\"logout\"\n      title=\"{{ 'asm.logout' | cxTranslate }}\"\n      *ngIf=\"customerSupportAgentLoggedIn$ | async\"\n      (click)=\"logout()\"\n    ></button>\n  </div>\n</div>\n\n<ng-container *ngIf=\"!(isCollapsed$ | async) as notCollapsed\">\n  <ng-container\n    *ngIf=\"customerSupportAgentLoggedIn$ | async; else showLoginForm\"\n  >\n    <ng-container *ngIf=\"customer$ | async; else showCustomerSelection\">\n      <cx-customer-emulation *ngIf=\"notCollapsed\"></cx-customer-emulation>\n      <cx-message\n        *ngIf=\"notCollapsed && showCreateCustomerSuccessfullyAlert\"\n        [text]=\"'asm.createCustomerSuccessfullyAlert' | cxTranslate\"\n        [type]=\"globalMessageType.MSG_TYPE_CONFIRMATION\"\n        (closeMessage)=\"closeDialogConfirmationAlert()\"\n      >\n      </cx-message>\n      <cx-message\n        *ngIf=\"showDeeplinkCartInfoAlert$ | async\"\n        [text]=\"deeplinkCartAlertKey | cxTranslate\"\n        [type]=\"globalMessageType.MSG_TYPE_INFO\"\n        (closeMessage)=\"closeDeeplinkCartInfoAlert()\"\n      >\n      </cx-message>\n      <cx-message\n        *ngIf=\"notCollapsed && showCustomerEmulationInfoAlert\"\n        [text]=\"'asm.startCustomerEmulationAlertInfo' | cxTranslate\"\n        [type]=\"globalMessageType.MSG_TYPE_INFO\"\n        (closeMessage)=\"closeCustomerEmulationInfoAlert()\"\n      >\n      </cx-message>\n    </ng-container>\n    <ng-template #showCustomerSelection>\n      <cx-customer-selection\n        *ngIf=\"notCollapsed\"\n        (submitEvent)=\"startCustomerEmulationSession($event, $event.parameters)\"\n      ></cx-customer-selection>\n    </ng-template>\n  </ng-container>\n\n  <ng-template #showLoginForm>\n    <cx-csagent-login-form\n      *ngIf=\"notCollapsed\"\n      (submitEvent)=\"loginCustomerSupportAgent($event)\"\n      [csAgentTokenLoading]=\"csAgentTokenLoading$ | async\"\n    ></cx-csagent-login-form>\n  </ng-template>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1$1.AuthService
  }, {
    type: i2$1.CsAgentAuthService
  }, {
    type: AsmComponentService
  }, {
    type: i1$1.GlobalMessageService
  }, {
    type: i1$1.RoutingService
  }, {
    type: i2$3.AsmService
  }, {
    type: i2$4.UserAccountFacade
  }, {
    type: i1.LaunchDialogService
  }], {
    disabled: [{
      type: HostBinding,
      args: ['class.hidden']
    }],
    element: [{
      type: ViewChild,
      args: ['customerListLink']
    }],
    addNewCustomerLink: [{
      type: ViewChild,
      args: ['addNewCustomerLink']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SWITCH_CUSTOMER_DIALOG_ACTION;
(function (SWITCH_CUSTOMER_DIALOG_ACTION) {
  SWITCH_CUSTOMER_DIALOG_ACTION["CANCEL"] = "CANCEL";
  SWITCH_CUSTOMER_DIALOG_ACTION["SWITCH"] = "SWITCH";
})(SWITCH_CUSTOMER_DIALOG_ACTION || (SWITCH_CUSTOMER_DIALOG_ACTION = {}));
class AsmSwitchCustomerDialogComponent {
  constructor(launchDialogService, asmComponentService) {
    this.launchDialogService = launchDialogService;
    this.asmComponentService = asmComponentService;
    this.SWITCH_CUSTOMER_DIALOG_ACTION = SWITCH_CUSTOMER_DIALOG_ACTION;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: true,
      focusOnEscape: true
    };
  }
  ngOnInit() {
    this.launchDialogService.data$.pipe(take(1)).subscribe(data => {
      this.curCustomerName = data.curCustomer.name || '';
      this.switchCustomerName = data.switchCustomer.name || '';
    });
  }
  closeModal(reason) {
    if (reason === SWITCH_CUSTOMER_DIALOG_ACTION.SWITCH) {
      this.asmComponentService.logoutCustomer();
    }
    this.launchDialogService.closeDialog(reason);
  }
  static {
    this.ɵfac = function AsmSwitchCustomerDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmSwitchCustomerDialogComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(AsmComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AsmSwitchCustomerDialogComponent,
      selectors: [["cx-asm-switch-customer-dialog"]],
      standalone: false,
      decls: 23,
      vars: 23,
      consts: [["role", "dialog", "aria-labelledby", "asm-switch-customer-dialog-title", 1, "cx-asm-switch-customer-dialog", "cx-modal-container", "cx-asm-dialog", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["type", "WARNING"], ["id", "asm-switch-customer-dialog-title", 1, "title", "modal-title"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row", "switch-customer-content"], [1, "cx-dialog-item"], [1, "cx-dialog-footer", "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"]],
      template: function AsmSwitchCustomerDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function AsmSwitchCustomerDialogComponent_Template_div_esc_0_listener() {
            return ctx.closeModal(ctx.SWITCH_CUSTOMER_DIALOG_ACTION.CANCEL);
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div")(4, "span");
          i0.ɵɵelement(5, "cx-icon", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "span", 4);
          i0.ɵɵtext(7);
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(9, "div", 5)(10, "div", 6)(11, "div", 7);
          i0.ɵɵtext(12);
          i0.ɵɵpipe(13, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(14, "div", 8)(15, "button", 9);
          i0.ɵɵpipe(16, "cxTranslate");
          i0.ɵɵlistener("click", function AsmSwitchCustomerDialogComponent_Template_button_click_15_listener() {
            return ctx.closeModal(ctx.SWITCH_CUSTOMER_DIALOG_ACTION.SWITCH);
          });
          i0.ɵɵtext(17);
          i0.ɵɵpipe(18, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(19, "button", 10);
          i0.ɵɵpipe(20, "cxTranslate");
          i0.ɵɵlistener("click", function AsmSwitchCustomerDialogComponent_Template_button_click_19_listener() {
            return ctx.closeModal(ctx.SWITCH_CUSTOMER_DIALOG_ACTION.CANCEL);
          });
          i0.ɵɵtext(21);
          i0.ɵɵpipe(22, "cxTranslate");
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(7);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 7, "asm.switchCustomer.dialog.title"), " ");
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 9, "asm.switchCustomer.dialog.body", i0.ɵɵpureFunction2(20, _c12, ctx.curCustomerName, ctx.switchCustomerName)), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(16, 12, "asm.switchCustomer.dialog.actions.switch"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 14, "asm.switchCustomer.dialog.actions.switch"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(20, 16, "common.cancel"));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 18, "common.cancel"), " ");
        }
      },
      dependencies: [i1.IconComponent, i1.FocusDirective, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmSwitchCustomerDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-asm-switch-customer-dialog',
      standalone: false,
      template: "<div\n  class=\"cx-asm-switch-customer-dialog cx-modal-container cx-asm-dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"closeModal(SWITCH_CUSTOMER_DIALOG_ACTION.CANCEL)\"\n  role=\"dialog\"\n  aria-labelledby=\"asm-switch-customer-dialog-title\"\n>\n  <div class=\"cx-modal-content\">\n    <!-- Modal Header -->\n    <div class=\"cx-dialog-header modal-header\">\n      <div>\n        <span>\n          <cx-icon type=\"WARNING\"></cx-icon>\n        </span>\n        <span id=\"asm-switch-customer-dialog-title\" class=\"title modal-title\">\n          {{ 'asm.switchCustomer.dialog.title' | cxTranslate }}\n        </span>\n      </div>\n    </div>\n\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <div class=\"cx-dialog-row switch-customer-content\">\n        <div class=\"cx-dialog-item\">\n          {{\n            'asm.switchCustomer.dialog.body'\n              | cxTranslate\n                : {\n                    customerA: curCustomerName,\n                    customerB: switchCustomerName,\n                  }\n          }}\n        </div>\n      </div>\n    </div>\n\n    <!-- Modal Footer -->\n    <div class=\"cx-dialog-footer modal-footer\">\n      <button\n        (click)=\"closeModal(SWITCH_CUSTOMER_DIALOG_ACTION.SWITCH)\"\n        [attr.aria-label]=\"\n          'asm.switchCustomer.dialog.actions.switch' | cxTranslate\n        \"\n        class=\"btn btn-primary\"\n        type=\"button\"\n      >\n        {{ 'asm.switchCustomer.dialog.actions.switch' | cxTranslate }}\n      </button>\n\n      <button\n        (click)=\"closeModal(SWITCH_CUSTOMER_DIALOG_ACTION.CANCEL)\"\n        [attr.aria-label]=\"'common.cancel' | cxTranslate\"\n        class=\"btn btn-secondary\"\n        type=\"button\"\n      >\n        {{ 'common.cancel' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }, {
    type: AsmComponentService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CustomerListComponent {
  constructor(launchDialogService, breakpointService, asmConfig, translation, asmCustomerListFacade, occConfig) {
    this.launchDialogService = launchDialogService;
    this.breakpointService = breakpointService;
    this.asmConfig = asmConfig;
    this.translation = translation;
    this.asmCustomerListFacade = asmCustomerListFacade;
    this.occConfig = occConfig;
    this.DEFAULT_PAGE_SIZE = 5;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'customer-list-selector',
      focusOnEscape: true
    };
    this.iconTypes = ICON_TYPE;
    this.BREAKPOINT = BREAKPOINT;
    this.currentPage = 0;
    this.maxPage = 0;
    this.loaded = false;
    this.listsError = false;
    this.listsEmpty = false;
    this.enableAsmB2bCustomerList = false;
    this.customerListColumnActionType = CustomerListColumnActionType;
    this.searchBox = new UntypedFormControl();
    this.forbiddenResponseStatus = HttpResponseStatus.FORBIDDEN;
    this.teardown = new Subscription();
    useFeatureStyles('a11yShowLabelOfSelect');
    this.breakpoint$ = this.getBreakpoint();
  }
  ngOnInit() {
    this.pageSize = this.asmConfig.asm?.customerList?.pageSize ?? this.DEFAULT_PAGE_SIZE;
    this.customerListConfig = this.asmConfig?.asm?.customerList;
    this.customerListsPage$ = this.asmCustomerListFacade.getCustomerListsState().pipe(tap(state => this.listsError = !!state.error), map(state => {
      if (state.error && typeof state.error === 'object' && 'status' in state.error && state.error.status === this.forbiddenResponseStatus) {
        this.launchDialogService.closeDialog(CLOSE_DIALOG_REASON.FORBIDDEN);
      }
      if (state?.data?.userGroups?.length === 0) {
        this.listsEmpty = true;
        return undefined;
      } else {
        return state.data;
      }
    }), distinctUntilChanged(), tap(result => {
      // set the first value of this.customerListsPage$ to be selected
      if (!this.selectedUserGroupId) {
        this.selectedUserGroupId = result?.userGroups?.[0]?.uid;
        this.sorts = null;
        this.fetchCustomers();
      }
    })) ?? NEVER;
    this.customerSearchLoading$ = this.asmCustomerListFacade.getCustomerListCustomersSearchResultsLoading().pipe(tap(loading => this.loaded = !loading));
    this.teardown.add(this.customerSearchLoading$.subscribe());
    this.teardown.add(() => this.asmCustomerListFacade.customerListCustomersSearchReset());
    this.customerSearchError$ = this.asmCustomerListFacade.getCustomerListCustomersSearchResultsError();
    this.customerSearchPage$ = this.asmCustomerListFacade.getCustomerListCustomersSearchResults().pipe(tap(result => {
      if (result?.sorts) {
        this.sorts = result.sorts;
        this.sortCode = result.pagination?.sort;
      }
      if (result?.entries.length < this.pageSize) {
        this.maxPage = result.pagination?.currentPage ?? 0;
      } else {
        this.maxPage = this.currentPage + 1;
      }
    }));
  }
  ngOnDestroy() {
    this.teardown.unsubscribe();
  }
  changePage(page) {
    const options = {
      customerListId: this.selectedUserGroupId,
      pageSize: this.pageSize,
      page: page,
      sort: this.sortCode
    };
    if (this.searchBox?.value) {
      options.query = this.searchBox.value;
    }
    this.asmCustomerListFacade.customerListCustomersSearch(options);
  }
  fetchCustomers() {
    this.enableAsmB2bCustomerList = this.selectedUserGroupId === 'b2bCustomerList';
    if (this.selectedUserGroupId) {
      const options = {
        customerListId: this.selectedUserGroupId,
        pageSize: this.pageSize,
        page: this.currentPage
      };
      if (this.sortCode) {
        options.sort = this.sortCode;
      }
      if (this.searchBox?.value) {
        options.query = this.searchBox.value;
      }
      this.asmCustomerListFacade.customerListCustomersSearchReset();
      this.asmCustomerListFacade.customerListCustomersSearch(options);
    }
    this.updateCustomerListColumns();
  }
  updateCustomerListColumns() {
    const columns = this.customerListConfig?.columns || [];
    for (const column of columns) {
      if (column.headerLocalizationKey === 'asm.customerList.tableHeader.account' || column.headerLocalizationKey === 'hideHeaders') {
        column.headerLocalizationKey = this.enableAsmB2bCustomerList ? 'asm.customerList.tableHeader.account' : 'hideHeaders';
      }
    }
  }
  onChangeCustomerGroup() {
    this.currentPage = 0;
    this.sorts = null;
    this.sortCode = '';
    this.fetchCustomers();
  }
  getGroupName(customerListsPage, id) {
    return customerListsPage?.userGroups?.find(userGroup => userGroup.uid === id)?.name ?? '';
  }
  getBadgeText(customerEntry) {
    return (customerEntry.firstName?.charAt(0) ?? '') + (customerEntry.lastName?.charAt(0) ?? '');
  }
  startColumnAction(customerEntry, action) {
    this.selectedCustomer = customerEntry;
    const closeValue = {
      actionType: action,
      selectedUser: customerEntry
    };
    this.closeModal(closeValue);
  }
  onKey(event) {
    if (event.key === 'Enter') {
      this.searchCustomers();
    }
  }
  searchCustomers() {
    this.currentPage = 0;
    this.fetchCustomers();
  }
  isRequired(customerEntry, type) {
    if (type === CustomerListColumnActionType.ACTIVE_CART && !customerEntry.lastCartId) {
      return true;
    }
    if (type === CustomerListColumnActionType.ORDER_HISTORY && customerEntry.hasOrder !== true) {
      return true;
    }
    return false;
  }
  changeSortCode(sortCode) {
    this.sortCode = sortCode;
    this.fetchCustomers();
  }
  goToNextPage() {
    if (this.currentPage >= this.maxPage) {
      this.currentPage = this.maxPage;
    } else {
      if (this.loaded) {
        this.currentPage++;
        this.fetchCustomers();
      }
    }
  }
  goToPreviousPage() {
    if (this.currentPage <= 0) {
      this.currentPage = 0;
    } else {
      if (this.loaded) {
        this.currentPage--;
        this.fetchCustomers();
      }
    }
  }
  closeModal(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  getSortLabels() {
    return combineLatest([this.translation.translate('asm.customerList.tableSort.byName'), this.translation.translate('asm.customerList.tableSort.byNameAsc'), this.translation.translate('asm.customerList.tableSort.byNameDesc'), this.translation.translate('asm.customerList.tableSort.byDateAsc'), this.translation.translate('asm.customerList.tableSort.byDateDesc'), this.translation.translate('asm.customerList.tableSort.byOrderDateAsc'), this.translation.translate('asm.customerList.tableSort.byOrderDateDesc'), this.translation.translate('asm.customerList.tableSort.byUnit'), this.translation.translate('asm.customerList.tableSort.byUnitDesc')]).pipe(map(([textByName, textByNameAsc, textByNameDesc, textByDateAsc, textByDateDesc, textByOrderDateAsc, textByOrderDateDesc, textByUnit, textByUnitDesc]) => {
      return {
        byName: textByName,
        byNameAsc: textByNameAsc,
        byNameDesc: textByNameDesc,
        byOrderDateAsc: textByOrderDateAsc,
        byOrderDateDesc: textByOrderDateDesc,
        byDateAsc: textByDateAsc,
        byDateDesc: textByDateDesc,
        byUnit: textByUnit,
        byUnitDesc: textByUnitDesc
      };
    }));
  }
  createCustomer() {
    this.launchDialogService.closeDialog('Create customer click');
    this.launchDialogService?.openDialogAndSubscribe(LAUNCH_CALLER.ASM_CREATE_CUSTOMER_FORM, this.addNewCustomerLink);
  }
  getBreakpoint() {
    return this.breakpointService.breakpoint$.pipe(map(breakpoint => {
      if (breakpoint === BREAKPOINT.lg || breakpoint === BREAKPOINT.xl) {
        breakpoint = BREAKPOINT.md;
      }
      return breakpoint;
    }));
  }
  static {
    this.ɵfac = function CustomerListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CustomerListComponent)(i0.ɵɵdirectiveInject(i1.LaunchDialogService), i0.ɵɵdirectiveInject(i1.BreakpointService), i0.ɵɵdirectiveInject(i2$1.AsmConfig), i0.ɵɵdirectiveInject(i1$1.TranslationService), i0.ɵɵdirectiveInject(i2$1.AsmCustomerListFacade), i0.ɵɵdirectiveInject(i1$1.OccConfig));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CustomerListComponent,
      selectors: [["cx-customer-list"]],
      viewQuery: function CustomerListComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c11, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addNewCustomerLink = _t.first);
        }
      },
      standalone: false,
      decls: 48,
      vars: 28,
      consts: [["cell", ""], ["cellContent", ""], ["search", ""], ["total", ""], ["sort", ""], ["pagination", ""], ["groupSelector", ""], ["closeButton", ""], ["createCustomerButton", ""], ["role", "dialog", "aria-labelledby", "asm-customer-list-title", 1, "cx-asm-customer-list", "cx-modal-container", "cx-asm-dialog", 3, "esc", "cxFocus"], [1, "cx-modal-content"], [1, "cx-dialog-header", "modal-header"], ["id", "asm-customer-list-title", 1, "title", "modal-title"], ["id", "asm-customer-list-desc", 1, "cx-visually-hidden"], [4, "ngTemplateOutlet"], ["class", "cx-dialog-sub-header modal-header", 3, "tablet-mobile", 4, "ngIf"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "cx-dialog-item"], ["class", "cx-error-state", 4, "ngIf"], [4, "ngIf"], ["class", "cx-dialog-sub-header modal-header cx-dialog-foot", 3, "asm-mobile-pagination", 4, "ngIf"], [1, "cx-dialog-footer", "modal-footer"], ["type", "button", 1, "btn", "cx-asm-customer-list-btn-cancel", 3, "click"], [1, "cx-dialog-sub-header", "modal-header"], [1, "cx-header-select"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cx-header-actions"], [1, "cx-error-state"], ["id", "asm-cusomer-list-table", "role", "table", "class", "table", 4, "ngIf"], ["class", "cx-empty-state", 4, "ngIf"], ["id", "asm-cusomer-list-table", "role", "table", 1, "table"], [1, "cx-visually-hidden"], ["role", "row", 4, "ngFor", "ngForOf"], ["role", "row"], ["role", "columnheader", 4, "ngFor", "ngForOf"], ["role", "columnheader"], ["role", "cell", "class", "cx-multi-cell", 4, "ngIf"], ["role", "cell", 4, "ngFor", "ngForOf"], ["role", "cell"], ["role", "cell", 1, "cx-multi-cell"], [4, "ngFor", "ngForOf"], [1, "cx-empty-state"], [1, "cx-dialog-sub-header", "modal-header", "cx-dialog-foot"], [3, "viewPageEvent", "pagination"], ["class", "cx-cell-container", 4, "ngIf"], [1, "cx-cell-container"], ["class", "cx-header-text", 4, "ngIf"], ["class", "cx-avatar", 4, "ngIf"], ["class", "btn btn-link cx-action-link cx-btn-cell", 3, "class", "disabled", "click", 4, "ngIf"], [1, "cx-header-text"], [1, "cx-avatar"], [3, "alt", "title", 4, "ngIf"], ["class", "cx-avatar-text", 4, "ngIf"], [3, "alt", "title"], [1, "cx-avatar-text"], [1, "btn", "btn-link", "cx-action-link", "cx-btn-cell", 3, "click", "disabled"], [3, "cx-action-color", "type", 4, "ngIf"], [3, "type"], [1, "form-group", "search-wrapper"], ["type", "text", 1, "form-control", 3, "keyup", "formControl", "placeholder"], ["role", "button", 1, "search", 3, "click", "type", "title"], ["class", "cx-total", 4, "ngIf"], [1, "cx-total"], ["class", "label-content", 4, "cxFeature"], ["class", "cx-visually-hidden", 4, "cxFeature"], ["ariaControls", "asm-cusomer-list-table", 1, "sort-selector", 3, "sortListEvent", "sortOptions", "sortLabels", "selectedOption", "placeholder", "ariaLabel"], [1, "label-content"], [1, "cx-pagination-buttons"], ["class", "btn btn-link cx-action-link cx-btn-previous", 3, "disabled", "click", 4, "ngIf"], ["class", "btn btn-link cx-action-link cx-btn-next", 3, "disabled", "click", 4, "ngIf"], [1, "btn", "btn-link", "cx-action-link", "cx-btn-previous", 3, "click", "disabled"], [1, "previous", 3, "type"], [1, "btn", "btn-link", "cx-action-link", "cx-btn-next", 3, "click", "disabled"], [1, "next", 3, "type"], ["bindLabel", "name", "bindValue", "uid", 1, "customer-list-selector", 3, "change", "ngModelChange", "searchable", "clearable", "tabIndex", "ngModel", "items", "cxNgSelectA11y"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], ["type", "button", 1, "btn", "cx-asm-create-customer-btn", 3, "click"]],
      template: function CustomerListComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 9);
          i0.ɵɵlistener("esc", function CustomerListComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal("Escape clicked"));
          });
          i0.ɵɵelementStart(1, "div", 10);
          i0.ɵɵelementContainerStart(2);
          i0.ɵɵelementStart(3, "div", 11)(4, "h2", 12);
          i0.ɵɵtext(5);
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 13);
          i0.ɵɵtext(8);
          i0.ɵɵpipe(9, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, CustomerListComponent_10_Template, 1, 0, null, 14);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, CustomerListComponent_div_11_Template, 11, 24, "div", 15);
          i0.ɵɵpipe(12, "async");
          i0.ɵɵelementStart(13, "div", 16)(14, "div", 17)(15, "div", 18);
          i0.ɵɵtemplate(16, CustomerListComponent_div_16_Template, 3, 3, "div", 19)(17, CustomerListComponent_div_17_Template, 3, 3, "div", 19)(18, CustomerListComponent_div_18_Template, 3, 3, "div", 19);
          i0.ɵɵpipe(19, "async");
          i0.ɵɵtemplate(20, CustomerListComponent_cx_spinner_20_Template, 1, 0, "cx-spinner", 20);
          i0.ɵɵpipe(21, "async");
          i0.ɵɵtemplate(22, CustomerListComponent_div_22_Template, 3, 2, "div", 20);
          i0.ɵɵpipe(23, "async");
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(24, CustomerListComponent_div_24_Template, 6, 11, "div", 21);
          i0.ɵɵpipe(25, "async");
          i0.ɵɵelementStart(26, "div", 22)(27, "button", 23);
          i0.ɵɵlistener("click", function CustomerListComponent_Template_button_click_27_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.closeModal("Cancel click"));
          });
          i0.ɵɵtext(28);
          i0.ɵɵpipe(29, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(30, CustomerListComponent_ng_template_30_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(32, CustomerListComponent_ng_template_32_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(34, CustomerListComponent_ng_template_34_Template, 7, 14, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(36, CustomerListComponent_ng_template_36_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(38, CustomerListComponent_ng_template_38_Template, 6, 11, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(40, CustomerListComponent_ng_template_40_Template, 6, 8, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(42, CustomerListComponent_ng_template_42_Template, 4, 10, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(44, CustomerListComponent_ng_template_44_Template, 5, 7, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(46, CustomerListComponent_ng_template_46_Template, 5, 4, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const createCustomerButton_r38 = i0.ɵɵreference(47);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 12, "asm.customerList.title"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 14, "asm.customerList.description"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngTemplateOutlet", createCustomerButton_r38);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 16, ctx.customerListsPage$));
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.listsEmpty);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.listsError);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(19, 18, ctx.customerSearchError$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(21, 20, ctx.customerSearchLoading$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(23, 22, ctx.customerSearchPage$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(25, 24, ctx.customerListsPage$));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 26, "asm.createCustomerForm.cancel"), " ");
        }
      },
      dependencies: [i5.NgForOf, i5.NgIf, i5.NgTemplateOutlet, i1$2.DefaultValueAccessor, i1$2.NgControlStatus, i1$2.FormControlDirective, i1.IconComponent, i6.NgSelectComponent, i1$2.NgModel, i1.SpinnerComponent, i1.FocusDirective, i1.NgSelectA11yDirective, i1.SortingComponent, i1.PaginationComponent, i1$1.FeatureDirective, i5.AsyncPipe, i1$1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomerListComponent, [{
    type: Component,
    args: [{
      selector: 'cx-customer-list',
      standalone: false,
      template: "<div\n  class=\"cx-asm-customer-list cx-modal-container cx-asm-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"closeModal('Escape clicked')\"\n  aria-labelledby=\"asm-customer-list-title\"\n>\n  <div class=\"cx-modal-content\">\n    <!-- Modal Header -->\n    <ng-container>\n      <div class=\"cx-dialog-header modal-header\">\n        <h2 id=\"asm-customer-list-title\" class=\"title modal-title\">\n          {{ 'asm.customerList.title' | cxTranslate }}\n        </h2>\n        <div id=\"asm-customer-list-desc\" class=\"cx-visually-hidden\">\n          {{ 'asm.customerList.description' | cxTranslate }}\n        </div>\n        <ng-template *ngTemplateOutlet=\"createCustomerButton\"></ng-template>\n      </div>\n      <div\n        class=\"cx-dialog-sub-header modal-header\"\n        [class.tablet-mobile]=\"(breakpoint$ | async) !== BREAKPOINT.md\"\n        *ngIf=\"customerListsPage$ | async as customerListsPage\"\n      >\n        <div\n          class=\"cx-header-select\"\n          [class.mobile]=\"(breakpoint$ | async) === BREAKPOINT.xs\"\n        >\n          <ng-template\n            *ngTemplateOutlet=\"\n              groupSelector;\n              context: { customerListsPage: customerListsPage }\n            \"\n          ></ng-template>\n          <ng-template\n            *ngTemplateOutlet=\"\n              total;\n              context: {\n                customerSearchPage: customerSearchPage$ | async,\n              }\n            \"\n          >\n          </ng-template>\n        </div>\n\n        <div\n          class=\"cx-header-actions\"\n          [class.mobile]=\"(breakpoint$ | async) === BREAKPOINT.xs\"\n        >\n          <ng-template *ngTemplateOutlet=\"sort\"></ng-template>\n          <ng-template *ngTemplateOutlet=\"search\"></ng-template>\n        </div>\n      </div>\n      <!-- Modal Body -->\n      <div class=\"cx-dialog-body modal-body\">\n        <div class=\"cx-dialog-row\">\n          <div class=\"cx-dialog-item\">\n            <div *ngIf=\"listsEmpty\" class=\"cx-error-state\">\n              {{ 'asm.customerList.noLists' | cxTranslate }}\n            </div>\n            <div *ngIf=\"listsError\" class=\"cx-error-state\">\n              {{ 'asm.customerList.listsError' | cxTranslate }}\n            </div>\n            <div *ngIf=\"customerSearchError$ | async\" class=\"cx-error-state\">\n              {{ 'generalErrors.pageFailure' | cxTranslate }}\n            </div>\n            <cx-spinner *ngIf=\"customerSearchLoading$ | async\"></cx-spinner>\n            <div *ngIf=\"customerSearchPage$ | async as customerSearchPage\">\n              <table\n                id=\"asm-cusomer-list-table\"\n                role=\"table\"\n                class=\"table\"\n                *ngIf=\"loaded\"\n              >\n                <caption class=\"cx-visually-hidden\">\n                  {{\n                    'asm.customerList.title' | cxTranslate\n                  }}\n                </caption>\n                <thead *ngIf=\"(breakpoint$ | async) === BREAKPOINT.md\">\n                  <tr role=\"row\">\n                    <th\n                      role=\"columnheader\"\n                      *ngFor=\"let column of customerListConfig?.columns\"\n                    >\n                      <span\n                        *ngIf=\"\n                          column.headerLocalizationKey &&\n                          column.headerLocalizationKey !== 'hideHeaders'\n                        \"\n                      >\n                        <ng-container\n                          *ngIf=\"\n                            column.headerLocalizationKey ===\n                            'asm.customerList.tableHeader.customer'\n                          \"\n                        >\n                          {{\n                            'asm.customerList.tableHeader.customerName'\n                              | cxTranslate\n                          }}\n                        </ng-container>\n                        <ng-container\n                          *ngIf=\"\n                            column.headerLocalizationKey ===\n                            'asm.customerList.tableHeader.email'\n                          \"\n                        >\n                          {{\n                            'asm.customerList.tableHeader.emailId' | cxTranslate\n                          }}\n                        </ng-container>\n                        <ng-container\n                          *ngIf=\"\n                            column.headerLocalizationKey !==\n                              'asm.customerList.tableHeader.customer' &&\n                            column.headerLocalizationKey !==\n                              'asm.customerList.tableHeader.email'\n                          \"\n                        >\n                          {{ column.headerLocalizationKey | cxTranslate }}\n                        </ng-container>\n                      </span>\n                    </th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr\n                    role=\"row\"\n                    *ngFor=\"let customerEntry of customerSearchPage?.entries\"\n                  >\n                    <!-- multi columns if desktop -->\n                    <ng-container\n                      *ngIf=\"(breakpoint$ | async) === BREAKPOINT.md\"\n                    >\n                      <td\n                        role=\"cell\"\n                        *ngFor=\"let column of customerListConfig?.columns\"\n                      >\n                        <ng-template\n                          *ngTemplateOutlet=\"\n                            cell;\n                            context: {\n                              customerEntry: customerEntry,\n                              column: column,\n                              showHeader: false,\n                            }\n                          \"\n                        ></ng-template>\n                      </td>\n                    </ng-container>\n                    <!-- two column if tablet -->\n                    <ng-container\n                      *ngIf=\"(breakpoint$ | async) === BREAKPOINT.sm\"\n                    >\n                      <td role=\"cell\" class=\"cx-multi-cell\">\n                        <ng-container\n                          *ngFor=\"\n                            let column of customerListConfig?.columns;\n                            let even = even\n                          \"\n                        >\n                          <ng-container *ngIf=\"even\">\n                            <ng-template\n                              *ngTemplateOutlet=\"\n                                cell;\n                                context: {\n                                  customerEntry: customerEntry,\n                                  column: column,\n                                  showHeader: true,\n                                }\n                              \"\n                            ></ng-template>\n                          </ng-container>\n                        </ng-container>\n                      </td>\n                      <td role=\"cell\" class=\"cx-multi-cell\">\n                        <ng-container\n                          *ngFor=\"\n                            let column of customerListConfig?.columns;\n                            let odd = odd\n                          \"\n                        >\n                          <ng-container *ngIf=\"odd\">\n                            <ng-template\n                              *ngTemplateOutlet=\"\n                                cell;\n                                context: {\n                                  customerEntry: customerEntry,\n                                  column: column,\n                                  showHeader: true,\n                                }\n                              \"\n                            ></ng-template>\n                          </ng-container>\n                        </ng-container>\n                      </td>\n                    </ng-container>\n                    <!-- one column if mobile -->\n                    <td\n                      role=\"cell\"\n                      class=\"cx-multi-cell\"\n                      *ngIf=\"(breakpoint$ | async) === BREAKPOINT.xs\"\n                    >\n                      <ng-container\n                        *ngFor=\"let column of customerListConfig?.columns\"\n                      >\n                        <ng-template\n                          *ngTemplateOutlet=\"\n                            cell;\n                            context: {\n                              customerEntry: customerEntry,\n                              column: column,\n                              showHeader: true,\n                            }\n                          \"\n                        ></ng-template>\n                      </ng-container>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n              <div\n                class=\"cx-empty-state\"\n                *ngIf=\"!customerSearchPage?.entries.length\"\n              >\n                {{ 'asm.customerList.noCustomers' | cxTranslate }}\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- Modal Foot -->\n      <div\n        class=\"cx-dialog-sub-header modal-header cx-dialog-foot\"\n        [class.asm-mobile-pagination]=\"(breakpoint$ | async) !== BREAKPOINT.md\"\n        *ngIf=\"customerListsPage$ | async as customerListsPage\"\n      >\n        <div\n          class=\"cx-header-actions\"\n          [class.mobile]=\"(breakpoint$ | async) === BREAKPOINT.xs\"\n        >\n          <div *ngIf=\"customerSearchPage$ | async as customerSearchPage\">\n            <cx-pagination\n              [pagination]=\"customerSearchPage.pagination\"\n              (viewPageEvent)=\"changePage($event)\"\n            ></cx-pagination>\n          </div>\n        </div>\n      </div>\n      <div class=\"cx-dialog-footer modal-footer\">\n        <button\n          type=\"button\"\n          class=\"btn cx-asm-customer-list-btn-cancel\"\n          (click)=\"closeModal('Cancel click')\"\n        >\n          {{ 'asm.createCustomerForm.cancel' | cxTranslate }}\n        </button>\n      </div>\n    </ng-container>\n  </div>\n</div>\n\n<ng-template\n  #cell\n  let-customerEntry=\"customerEntry\"\n  let-column=\"column\"\n  let-showHeader=\"showHeader\"\n>\n  <div\n    class=\"cx-cell-container\"\n    *ngIf=\"column.headerLocalizationKey !== 'hideHeaders'\"\n  >\n    <span class=\"cx-header-text\" *ngIf=\"showHeader\">\n      {{ column.headerLocalizationKey | cxTranslate }}\n    </span>\n\n    <ng-container *ngIf=\"!column.actionType\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          cellContent;\n          context: { column: column, customerEntry: customerEntry }\n        \"\n      ></ng-container>\n    </ng-container>\n\n    <div\n      class=\"cx-avatar\"\n      *ngIf=\"\n        customerListConfig?.showAvatar &&\n        column?.actionType === customerListColumnActionType?.START_SESSION\n      \"\n    >\n      <img\n        *ngIf=\"customerEntry?.userAvatar?.url\"\n        [attr.src]=\"\n          occConfig?.backend?.occ?.baseUrl + customerEntry?.userAvatar?.url\n        \"\n        alt=\"{{ 'asm.mainLogoLabel' | cxTranslate }}\"\n        title=\"{{ 'asm.mainLogoLabel' | cxTranslate }}\"\n      />\n      <div class=\"cx-avatar-text\" *ngIf=\"!customerEntry?.userAvatar?.url\">\n        {{ getBadgeText(customerEntry) }}\n      </div>\n    </div>\n\n    <button\n      *ngIf=\"column.actionType\"\n      (click)=\"startColumnAction(customerEntry, column.actionType)\"\n      class=\"btn btn-link cx-action-link cx-btn-cell\"\n      [class]=\"\n        (column.actionType === 'ACTIVE_CART' ? 'cx-cart ' : '') +\n        (column.actionType !== 'START_SESSION' ? 'cx-action-disable' : '')\n      \"\n      [disabled]=\"isRequired(customerEntry, column.actionType)\"\n      [attr.title]=\"\n        column.icon\n          ? (column.icon.captionLocalizationKey ?? column.headerLocalizationKey\n            | cxTranslate)\n          : undefined\n      \"\n      [attr.aria-label]=\"\n        column.icon\n          ? (column.icon.captionLocalizationKey ?? column.headerLocalizationKey\n            | cxTranslate)\n          : undefined\n      \"\n    >\n      <ng-container\n        *ngTemplateOutlet=\"\n          cellContent;\n          context: { column: column, customerEntry: customerEntry }\n        \"\n      ></ng-container>\n    </button>\n  </div>\n</ng-template>\n<ng-template #cellContent let-customerEntry=\"customerEntry\" let-column=\"column\">\n  <div>\n    <span *ngIf=\"!column.icon\">{{\n      column.renderer?.(customerEntry) || ''\n    }}</span>\n    <cx-icon\n      *ngIf=\"column.icon\"\n      [attr.title]=\"\n        !column.actionType\n          ? (column.icon.captionLocalizationKey ?? column.headerLocalizationKey\n            | cxTranslate)\n          : undefined\n      \"\n      [class.cx-action-color]=\"\n        column.actionType && !isRequired(customerEntry, column.actionType)\n      \"\n      [type]=\"column.icon.symbol\"\n      [attr.aria-label]=\"\n        !column.actionType\n          ? (column.icon.captionLocalizationKey ?? column.headerLocalizationKey\n            | cxTranslate)\n          : undefined\n      \"\n    ></cx-icon>\n  </div>\n</ng-template>\n\n<ng-template #search>\n  <div class=\"form-group search-wrapper\">\n    <input\n      [formControl]=\"searchBox\"\n      (keyup)=\"onKey($event)\"\n      type=\"text\"\n      class=\"form-control\"\n      placeholder=\"{{ 'asm.customerList.searchBox' | cxTranslate }}\"\n      attr.aria-label=\"{{ 'asm.customerList.enterSearchBox' | cxTranslate }}\"\n    />\n    <cx-icon\n      [type]=\"iconTypes.SEARCH\"\n      role=\"button\"\n      [attr.aria-label]=\"'storeFinder.searchNearestStores' | cxTranslate\"\n      [title]=\"'storeFinder.searchNearestStores' | cxTranslate\"\n      class=\"search\"\n      (click)=\"searchCustomers()\"\n    ></cx-icon>\n  </div>\n</ng-template>\n\n<ng-template #total let-customerSearchPage=\"customerSearchPage\">\n  <span class=\"cx-total\" *ngIf=\"customerSearchPage?.pagination?.totalResults\">\n    <ng-container *ngIf=\"customerSearchPage?.pagination?.totalResults > 1\">\n      {{\n        'asm.customerList.noOfCustomers'\n          | cxTranslate: { count: customerSearchPage?.pagination?.totalResults }\n      }}\n    </ng-container>\n    <ng-container *ngIf=\"customerSearchPage?.pagination?.totalResults === 1\">\n      {{ 'asm.customerList.oneCustomer' | cxTranslate }}\n    </ng-container>\n  </span>\n</ng-template>\n\n<ng-template #sort>\n  <label>\n    <span *cxFeature=\"'a11yShowLabelOfSelect'\" class=\"label-content\">{{\n      'asm.customerList.tableSort.sortBy' | cxTranslate\n    }}</span>\n    <span *cxFeature=\"'!a11yShowLabelOfSelect'\" class=\"cx-visually-hidden\">{{\n      'asm.customerList.tableSort.sortBy' | cxTranslate\n    }}</span>\n    <cx-sorting\n      class=\"sort-selector\"\n      [sortOptions]=\"sorts\"\n      [sortLabels]=\"getSortLabels() | async\"\n      (sortListEvent)=\"changeSortCode($event)\"\n      [selectedOption]=\"sortCode\"\n      placeholder=\"{{ 'asm.customerList.tableSort.sortBy' | cxTranslate }}\"\n      [ariaLabel]=\"sortCode\"\n      ariaControls=\"asm-cusomer-list-table\"\n    ></cx-sorting>\n  </label>\n</ng-template>\n\n<ng-template #pagination>\n  <div class=\"cx-pagination-buttons\">\n    <div>\n      {{\n        'asm.customerList.page.page' | cxTranslate: { count: currentPage + 1 }\n      }}\n    </div>\n    <button\n      *ngIf=\"maxPage > 0\"\n      (click)=\"goToPreviousPage()\"\n      class=\"btn btn-link cx-action-link cx-btn-previous\"\n      [disabled]=\"currentPage === 0 || !loaded\"\n    >\n      <cx-icon class=\"previous\" [type]=\"iconTypes.CARET_LEFT\"></cx-icon\n      ><span>{{ 'asm.customerList.page.previous' | cxTranslate }}</span>\n    </button>\n    <button\n      *ngIf=\"maxPage > 0\"\n      (click)=\"goToNextPage()\"\n      class=\"btn btn-link cx-action-link cx-btn-next\"\n      [disabled]=\"currentPage === maxPage || !loaded\"\n    >\n      <span>{{ 'asm.customerList.page.next' | cxTranslate }}</span\n      ><cx-icon class=\"next\" [type]=\"iconTypes.CARET_RIGHT\"></cx-icon>\n    </button>\n  </div>\n</ng-template>\n\n<ng-template #groupSelector let-customerListsPage=\"customerListsPage\">\n  <label>\n    <span *cxFeature=\"'a11yShowLabelOfSelect'\" class=\"label-content\">{{\n      'asm.customerList.title' | cxTranslate\n    }}</span>\n    <span *cxFeature=\"'!a11yShowLabelOfSelect'\" class=\"cx-visually-hidden\">{{\n      'asm.customerList.title' | cxTranslate\n    }}</span>\n    <ng-select\n      class=\"customer-list-selector\"\n      [searchable]=\"false\"\n      [clearable]=\"false\"\n      (change)=\"onChangeCustomerGroup()\"\n      [tabIndex]=\"0\"\n      [(ngModel)]=\"selectedUserGroupId\"\n      [items]=\"customerListsPage?.userGroups\"\n      bindLabel=\"name\"\n      bindValue=\"uid\"\n      [cxNgSelectA11y]=\"{\n        ariaLabel: getGroupName(customerListsPage, selectedUserGroupId),\n        ariaControls: 'asm-cusomer-list-table',\n      }\"\n    >\n    </ng-select>\n  </label>\n</ng-template>\n\n<ng-template #closeButton>\n  <button\n    type=\"button\"\n    class=\"close\"\n    attr.aria-label=\"{{ 'common.close' | cxTranslate }}\"\n    (click)=\"closeModal('Cross click')\"\n    title=\"{{ 'common.close' | cxTranslate }}\"\n  >\n    <span aria-hidden=\"true\">\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </span>\n  </button>\n</ng-template>\n\n<ng-template #createCustomerButton>\n  <button\n    type=\"button\"\n    class=\"btn cx-asm-create-customer-btn\"\n    (click)=\"createCustomer()\"\n  >\n    <cx-icon [type]=\"iconTypes.USER_PLUS\"></cx-icon>\n    <span>{{ 'asm.customerList.createCustomer' | cxTranslate }}</span>\n  </button>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.LaunchDialogService
  }, {
    type: i1.BreakpointService
  }, {
    type: i2$1.AsmConfig
  }, {
    type: i1$1.TranslationService
  }, {
    type: i2$1.AsmCustomerListFacade
  }, {
    type: i1$1.OccConfig
  }], {
    addNewCustomerLink: [{
      type: ViewChild,
      args: ['addNewCustomerLink']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCustomerListLayoutConfig = {
  launch: {
    ASM_CUSTOMER_LIST: {
      inlineRoot: true,
      component: CustomerListComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultAsmLayoutConfig = {
  launch: {
    ASM: {
      outlet: 'cx-storefront',
      component: AsmMainUiComponent
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultAsmPaginationConfig = {
  pagination: {
    rangeCount: 2,
    addPrevious: true,
    addNext: true,
    addStart: false,
    addEnd: false,
    addFirst: true,
    addLast: true,
    addDots: true,
    substituteDotsForSingularPage: true,
    dotsLabel: '···'
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultBindCartLayoutConfig = {
  launch: {
    [LAUNCH_CALLER.ASM_BIND_CART]: {
      inlineRoot: true,
      component: AsmBindCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSaveCartLayoutConfig = {
  launch: {
    [LAUNCH_CALLER.ASM_SAVE_CART]: {
      inlineRoot: true,
      component: AsmSaveCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSwitchCustomerLayoutConfig = {
  launch: {
    [LAUNCH_CALLER.ASM_SWITCH_CUSTOMER]: {
      inlineRoot: true,
      component: AsmSwitchCustomerDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AsmComponentsModule {
  static {
    this.ɵfac = function AsmComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AsmComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AsmComponentsModule,
      declarations: [AsmBindCartDialogComponent, AsmSaveCartDialogComponent, AsmMainUiComponent, CSAgentLoginFormComponent, CustomerListComponent, CustomerSelectionComponent, AsmSessionTimerComponent, FormatTimerPipe, CustomerEmulationComponent, AsmToggleUiComponent, AsmBindCartComponent, AsmSwitchCustomerDialogComponent, DotSpinnerComponent, AsmCreateCustomerFormComponent],
      imports: [CommonModule, ReactiveFormsModule, I18nModule, FormErrorsModule, IconModule, NgSelectModule, FormsModule, SpinnerModule, PasswordVisibilityToggleModule, KeyboardFocusModule, NgSelectA11yModule, SortingModule, PaginationModule, MessageComponentModule, FeaturesConfigModule],
      exports: [AsmBindCartDialogComponent, AsmSaveCartDialogComponent, AsmMainUiComponent, CSAgentLoginFormComponent, CustomerListComponent, CustomerSelectionComponent, AsmSessionTimerComponent, FormatTimerPipe, CustomerEmulationComponent, AsmToggleUiComponent, AsmBindCartComponent, AsmSwitchCustomerDialogComponent, DotSpinnerComponent, AsmCreateCustomerFormComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultAsmLayoutConfig), provideDefaultConfig(defaultBindCartLayoutConfig), provideDefaultConfig(defaultSaveCartLayoutConfig), provideDefaultConfig(defaultSwitchCustomerLayoutConfig), provideDefaultConfig(defaultCustomerListLayoutConfig), provideDefaultConfig(defaultAsmPaginationConfig), provideDefaultConfig(defaultAsmCreateCustomerFormLayoutConfig)],
      imports: [CommonModule, ReactiveFormsModule, I18nModule, FormErrorsModule, IconModule, NgSelectModule, FormsModule, SpinnerModule, PasswordVisibilityToggleModule, KeyboardFocusModule, NgSelectA11yModule, SortingModule, PaginationModule, MessageComponentModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AsmComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, I18nModule, FormErrorsModule, IconModule, NgSelectModule, FormsModule, SpinnerModule, PasswordVisibilityToggleModule, KeyboardFocusModule, NgSelectA11yModule, SortingModule, PaginationModule, MessageComponentModule, FeaturesConfigModule],
      declarations: [AsmBindCartDialogComponent, AsmSaveCartDialogComponent, AsmMainUiComponent, CSAgentLoginFormComponent, CustomerListComponent, CustomerSelectionComponent, AsmSessionTimerComponent, FormatTimerPipe, CustomerEmulationComponent, AsmToggleUiComponent, AsmBindCartComponent, AsmSwitchCustomerDialogComponent, DotSpinnerComponent, AsmCreateCustomerFormComponent],
      exports: [AsmBindCartDialogComponent, AsmSaveCartDialogComponent, AsmMainUiComponent, CSAgentLoginFormComponent, CustomerListComponent, CustomerSelectionComponent, AsmSessionTimerComponent, FormatTimerPipe, CustomerEmulationComponent, AsmToggleUiComponent, AsmBindCartComponent, AsmSwitchCustomerDialogComponent, DotSpinnerComponent, AsmCreateCustomerFormComponent],
      providers: [provideDefaultConfig(defaultAsmLayoutConfig), provideDefaultConfig(defaultBindCartLayoutConfig), provideDefaultConfig(defaultSaveCartLayoutConfig), provideDefaultConfig(defaultSwitchCustomerLayoutConfig), provideDefaultConfig(defaultCustomerListLayoutConfig), provideDefaultConfig(defaultAsmPaginationConfig), provideDefaultConfig(defaultAsmCreateCustomerFormLayoutConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AsmBindCartComponent, AsmBindCartDialogComponent, AsmComponentService, AsmComponentsModule, AsmCreateCustomerFormComponent, AsmMainUiComponent, AsmSaveCartDialogComponent, AsmSessionTimerComponent, AsmSwitchCustomerDialogComponent, AsmToggleUiComponent, BIND_CART_DIALOG_ACTION, CART_TYPE_KEY, CSAgentLoginFormComponent, CustomerEmulationComponent, CustomerListComponent, CustomerSelectionComponent, DotSpinnerComponent, FormatTimerPipe, SAVE_CART_DIALOG_ACTION, SWITCH_CUSTOMER_DIALOG_ACTION };
